
export var gl: WebGL2RenderingContext;
export function setGL(_gl: WebGL2RenderingContext) {
  gl = _gl;
}

export let skullString: string = 
`
# This file uses centimeters as units for non-parametric coordinates.

mtllib skull.mtl
g default
v -471.174897 857.575798 -251.102698
v -108.216910 735.105705 -576.135219
v -32.273104 616.757115 -629.005089
v 52.201400 473.626850 -667.075026
v 173.040868 318.842595 -683.904056
v 299.334275 142.275186 -655.409855
v 423.426283 -10.184590 -591.296874
v 483.113692 -144.335147 -476.726472
v 529.430992 -217.153887 -354.239009
v -441.562830 810.210356 -383.507541
v 28.097515 770.185854 -519.231993
v 95.217259 660.049711 -568.560967
v 169.656578 519.100012 -598.658379
v 252.331427 346.893544 -686.750580
v 397.636942 190.549508 -678.307382
v 547.952295 50.726384 -740.619763
v 642.278848 -71.654864 -701.271232
v 666.057530 -172.641646 -619.550339
v -416.581361 725.214442 -534.901275
v 183.977259 823.250876 -414.593696
v 243.926812 723.152654 -452.568322
v 231.047244 534.286068 -513.094144
v 313.358393 325.306490 -649.575203
v 476.989133 174.900532 -589.618762
v 640.767168 98.855715 -531.530864
v 719.993742 -66.165362 -434.929540
v 759.706250 -199.538950 -413.980584
v -189.788260 834.489761 -487.097964
v 252.433399 848.131050 -328.788326
v 314.267660 763.546354 -360.396676
v 334.639741 625.630506 -373.547729
v 631.132689 171.984731 -404.084176
v 702.419162 132.665465 -398.811824
v 754.121523 -38.885503 -380.212524
v 894.963669 -287.062961 -411.476212
v -264.901162 904.293641 -343.752886
v 301.884980 864.921306 -216.996045
v 371.883086 772.014117 -242.814184
v 454.855020 583.307415 -225.014202
v 542.766337 428.509453 -168.335307
v 662.092211 241.728936 -242.896271
v 740.147739 157.839135 -268.649752
v 813.013525 -22.574883 -287.709165
v 1037.445351 -281.342977 -330.638307
v 436.304930 403.577039 -195.373112
v 330.282659 522.578318 -241.361017
v -282.880608 951.255899 -207.542476
v 345.540903 872.802251 -119.534831
v 424.059125 773.155054 -137.706110
v 484.666061 612.326727 -149.405283
v 585.734003 449.493664 -133.271705
v 716.358240 323.115842 -151.088519
v 750.628342 241.102253 -108.280461
v 800.931885 91.653567 -102.478187
v 1069.816604 -186.907698 -166.132323
v 189.097491 466.622257 -445.903205
v 236.025581 320.962761 -524.054884
v 411.626448 205.984977 -507.465213
v -321.771530 956.681986 -129.910041
v -1199.876939 292.607695 -51.907543
v -1169.623810 64.675785 -42.028695
v -1127.894632 -179.064721 -32.207405
v -1043.228378 -431.045542 -35.496277
v -869.912020 -604.592230 -36.668898
v -657.874398 -720.597956 -37.606004
v -374.572447 -847.076932 -25.826250
v -304.684785 -713.330131 -43.657233
v 513.181012 205.617192 -370.289882
v 235.876343 541.742020 -355.035096
v 528.609393 276.844318 -238.201182
v 950.149868 -195.183900 -160.576976
v 757.732897 -159.911681 -328.378282
v 974.854607 -178.474641 -72.947938
v 883.139197 -298.682462 -355.400638
v 706.650952 -167.788575 -345.722951
v 994.636930 -210.056643 -77.711643
v 997.905114 -211.906786 -166.132314
v 965.533607 -306.341657 -307.803151
v 91.774704 295.901363 -211.531290
v 79.592811 314.862824 -208.861911
v 65.951841 334.441565 -211.888114
v -348.205762 958.389139 -63.317237
v -1061.200348 296.787421 -411.028515
v -1044.208041 130.253857 -460.164891
v -978.014611 -89.582774 -491.378616
v -883.496642 -321.933199 -496.108754
v -754.603913 -498.313066 -474.148222
v -546.075128 -605.096272 -488.746369
v -315.793856 -736.852846 -430.661367
v -194.873403 -598.976677 -359.813721
v 89.612609 287.114707 -224.520428
v 52.517041 337.160521 -224.010055
v 75.748912 287.207543 -237.106356
v 50.576578 302.392121 -239.798344
v 46.606785 324.001467 -232.361595
v 18.975132 382.565205 -283.116343
v -15.201540 1007.550537 -63.036829
v -907.022459 354.019222 -556.226807
v -897.116938 187.488706 -639.346700
v -833.196104 -13.385773 -683.458826
v -723.066226 -210.124023 -686.140856
v -586.096455 -387.242226 -644.126746
v -418.874246 -505.452246 -589.942804
v -222.705160 -639.177510 -486.781196
v -109.490799 -463.080428 -353.334684
v 34.280744 299.249913 -314.710702
v 131.332794 240.705061 -303.274009
v 41.762199 433.300157 -247.635634
v 184.784593 240.347387 -249.803894
v 93.560374 422.817184 -196.136845
v 146.153109 347.330853 -183.279656
v -27.982482 1005.450015 -112.759978
v -726.630087 450.190458 -637.187698
v -690.843160 297.356165 -724.979403
v -611.457707 113.070366 -770.290871
v -502.294089 -75.108077 -766.863712
v -373.091861 -246.725916 -725.354050
v -226.980250 -389.178078 -640.196481
v -100.472955 -450.280818 -515.691848
v 13.027833 -325.945926 -348.473313
v 193.120856 274.224463 -194.620463
v 338.019446 279.621144 -233.260927
v 265.292399 371.609213 -201.573900
v 190.605445 466.884682 -231.876182
v 328.204829 230.271364 -322.264222
v 122.670275 476.793555 -309.438020
v -39.288273 977.533166 -200.269905
v -383.761476 646.757767 -620.671392
v -330.730334 514.291323 -702.040293
v -230.519707 340.843303 -736.349982
v -119.194084 167.968654 -740.261158
v -10.136247 1.878964 -706.537295
v 83.455886 -129.819774 -635.023045
v 228.741969 -180.418514 -504.804711
v 245.363634 -176.436170 -356.409505
v 740.889698 357.498266 -89.824752
v 599.486419 468.760323 -86.244548
v 255.172408 235.843825 -409.782086
v 122.863996 314.895527 -414.571794
v 722.339165 300.584204 -51.144872
v 858.871310 45.912138 -42.838787
v -54.965603 930.849518 -315.229999
v 1066.548571 -185.057798 -82.474963
v 352.818598 868.738576 -68.518112
v 432.659237 773.555330 -80.658450
v 510.353574 606.359553 -83.220950
v 91.027689 416.128294 -363.248444
v -48.286685 868.250252 -425.066783
v 88.105664 881.521129 -367.553011
v 117.814820 907.137865 -295.200889
v 144.311702 923.534404 -189.851086
v 160.063037 932.095987 -109.437649
v -1122.185810 451.041352 -66.007465
v -979.571068 444.957274 -396.101403
v -897.845213 460.230378 -495.171780
v -757.457531 547.118687 -533.345741
v 175.417089 932.903418 -60.938433
v -491.256730 879.930939 -158.365004
v -510.314853 892.974676 -70.625725
v -896.836596 608.835412 -255.873146
v -830.636816 581.502456 -398.652273
v -941.020538 600.131327 -152.190345
v -953.849226 607.055328 -64.496834
v -1079.667827 421.056476 -256.954961
v 596.786768 -298.010018 -187.543874
v -1111.280082 433.847642 -140.179214
v 787.129037 -244.601767 -166.943558
v -1069.645178 -150.703732 -303.931545
v -1127.529371 75.335789 -289.761625
v -967.830295 -377.645356 -314.743550
v -813.339867 -547.895285 -315.719242
v -621.579078 -670.723211 -320.595990
v -352.856073 -776.526487 -297.850725
v -266.632380 -700.064405 -314.814305
v -1133.695792 287.775788 -270.465961
v 806.227860 -254.847817 -74.344634
v -1106.964264 -169.094186 -141.475796
v -1010.794431 -407.702160 -143.912942
v -847.625987 -580.511126 -139.936858
v -644.891125 -708.138674 -130.098302
v -381.584570 -812.203490 -119.984752
v -297.463873 -709.281602 -116.625811
v -1177.644329 292.203170 -138.443859
v 622.524408 -328.656881 -80.213259
v -1158.361510 66.591037 -136.463057
v -198.506908 -598.425186 -188.679822
v -96.411231 -431.821203 -188.167164
v 143.842875 -115.820624 -154.494377
v 412.339897 -371.475975 -168.005370
v -195.220465 -593.272460 -61.071416
v -72.428464 -392.284078 -72.383554
v 133.756869 -77.549468 -55.687412
v 456.027062 -441.221481 -63.587472
v -470.835876 858.004646 250.840652
v -108.222650 735.102832 576.329076
v -32.299102 616.750743 629.175244
v 52.055454 473.654235 667.148435
v 173.041043 318.842314 684.104319
v 299.106344 142.350592 655.543381
v 423.341619 -10.185692 591.481198
v 483.093460 -144.348569 476.930869
v 529.430899 -217.171255 354.445770
v -441.525870 810.276075 383.628174
v 28.090686 770.168999 519.423860
v 95.194847 659.968536 568.729701
v 169.674917 518.645673 598.833172
v 252.331608 346.893255 695.896409
v 395.859878 190.302787 678.304346
v 547.646562 50.634916 740.717117
v 642.191067 -71.686292 701.434008
v 666.031693 -172.650790 619.739230
v -416.582533 725.214584 535.100995
v 183.955594 823.233185 414.779663
v 243.826489 723.077830 452.705307
v 230.377477 533.796118 512.880988
v 295.951713 316.718415 639.564592
v 474.443846 173.637730 588.344591
v 640.249961 98.580503 531.406682
v 719.935751 -66.196741 435.092423
v 759.706358 -199.539122 414.180370
v -189.789919 834.489804 487.297693
v 252.426965 848.125961 328.984597
v 314.251821 763.534542 360.586877
v 334.534648 625.554493 373.682991
v 630.878682 171.856583 404.133922
v 702.362620 132.633658 398.973864
v 754.099449 -38.897781 380.398104
v 894.963777 -287.063133 411.675996
v -264.907653 904.297357 343.960070
v 301.882949 864.919609 217.195086
v 371.876767 772.009293 243.010544
v 454.838451 583.295601 225.204189
v 542.757703 428.504734 168.530262
v 662.048659 241.707022 243.070554
v 740.126436 157.827692 268.836134
v 813.004450 -22.580067 287.903047
v 1037.445422 -281.343090 330.837876
v 436.285051 403.566377 195.561499
v 330.248995 522.557237 241.540842
v -282.899121 951.274540 207.744876
v 345.540908 872.802243 119.735284
v 424.059178 773.154970 137.906292
v 484.661496 612.323416 149.602515
v 585.731319 449.492110 133.470238
v 716.358252 323.115822 151.288562
v 750.628323 241.102282 108.480413
v 800.930213 91.652643 102.676995
v 1069.816702 -186.907855 166.332134
v 188.526010 466.298951 445.762826
v 231.622917 318.783208 521.671558
v 409.847769 205.104320 506.627328
v -321.616856 956.734132 130.269908
v -1208.266495 287.370222 51.932999
v -1169.623741 64.675675 42.246979
v -1127.894612 -179.064753 32.425726
v -1043.228372 -431.045553 35.714441
v -869.912013 -604.592240 36.886858
v -657.874417 -720.597925 37.823817
v -374.572426 -847.076965 26.025977
v -304.684767 -713.330159 43.857025
v 512.811422 205.433463 370.273653
v 235.731306 541.653246 355.147952
v 528.537499 276.808455 238.359125
v 950.149967 -195.184059 160.776698
v 757.734606 -159.912344 328.580679
v 974.854620 -178.474662 73.147767
v 883.139264 -298.682568 355.600329
v 706.651419 -167.793273 345.924579
v 994.636992 -210.056743 77.911364
v 997.905111 -211.906781 166.332143
v 965.533681 -306.341776 308.002904
v 91.774783 295.901238 211.731354
v 79.592890 314.862698 209.062016
v 65.951931 334.441420 212.088402
v -347.969234 958.460573 63.808456
v -1061.207522 296.796360 411.233200
v -1044.209030 130.255436 460.368194
v -978.013627 -89.583268 491.585470
v -883.496672 -321.932792 496.313159
v -754.603822 -498.313570 474.350217
v -546.073369 -605.098363 488.947188
v -315.770686 -736.870074 430.881287
v -194.866140 -598.981446 360.024755
v 89.612666 287.114616 224.720590
v 52.517129 337.160379 224.210198
v 75.748986 287.207425 237.306420
v 50.576651 302.392003 239.998447
v 46.606859 324.001348 232.561692
v 18.975211 382.565079 283.316515
v -15.200307 1007.550545 63.238615
v -907.083323 354.112349 556.339664
v -897.116996 187.489697 639.551539
v -833.189755 -13.390880 683.692578
v -723.067804 -210.118988 686.360803
v -586.098312 -387.243932 644.333699
v -418.872628 -505.455907 590.140375
v -222.621827 -639.239406 487.059660
v -109.490257 -463.080575 353.556281
v 34.280818 299.249795 314.910899
v 131.332876 240.704931 303.474143
v 41.762271 433.300042 247.835939
v 184.784659 240.347283 250.003989
v 93.560467 422.817035 196.337043
v 146.153180 347.330741 183.479883
v -27.983097 1005.450009 112.959951
v -726.711357 450.448297 637.172911
v -690.807929 297.302883 725.149724
v -610.909366 111.566524 770.818835
v -502.706169 -74.591409 767.257277
v -373.223001 -246.533350 725.618412
v -226.789036 -389.345641 640.317283
v -100.950798 -451.062528 516.103081
v 12.854685 -326.130717 348.682735
v 193.120906 274.224384 194.820693
v 337.954054 279.588464 233.422747
v 265.275468 371.600132 201.764103
v 190.581694 466.870679 232.062150
v 327.952472 230.146063 322.316524
v 122.599334 476.753117 309.595889
v -39.288792 977.532916 200.470432
v -383.763775 646.758697 620.873856
v -330.736562 514.289992 702.246569
v -230.536094 340.845299 736.543685
v -119.199945 167.968354 740.463224
v -10.156275 1.882014 706.740044
v 83.452169 -129.832344 635.250021
v 228.770061 -180.457388 505.096336
v 245.363086 -176.448814 356.616541
v 740.889711 357.498245 90.024825
v 599.485425 468.759754 86.443984
v 254.423940 235.472782 409.543742
v 121.931721 314.431851 414.224402
v 722.339138 300.584248 51.344934
v 858.871278 45.912190 43.038679
v -54.968950 930.848214 315.432156
v 1066.548633 -185.057897 82.674773
v 352.818612 868.738554 68.718483
v 432.659299 773.555231 80.858741
v 510.352196 606.358609 83.420190
v 90.858624 416.036964 363.348293
v -48.288094 868.247560 425.265716
v 88.101310 881.516851 367.750343
v 117.812893 907.135643 295.399840
v 144.310998 923.533641 190.050943
v 160.062832 932.095956 109.637888
v -1122.184559 451.042949 66.206270
v -979.642291 444.936779 396.288372
v -897.821585 460.184034 495.489174
v -757.508679 547.035422 533.637100
v 175.417013 932.903450 61.138698
v -491.370167 880.245589 158.776672
v -509.648042 893.649178 74.190912
v -896.343092 608.888057 257.577524
v -830.899546 581.576154 398.657889
v -941.001580 600.111750 152.382953
v -953.844167 607.049856 64.700811
v -1079.673646 421.070257 257.165046
v 597.230691 -297.760635 188.174052
v -1111.277745 433.852534 140.387049
v 786.819679 -244.784283 167.036811
v -1069.644754 -150.703690 304.133250
v -1127.528773 75.336272 289.963116
v -967.830260 -377.645413 314.944761
v -813.339716 -547.895526 315.919953
v -621.578376 -670.723973 320.796528
v -352.851722 -776.529839 298.053864
v -266.632206 -700.064684 315.014196
v -1133.695255 287.779602 270.669159
v 806.270618 -254.832991 74.543000
v -1106.964025 -169.094208 141.676546
v -1010.794255 -407.702081 144.113343
v -847.625922 -580.511229 140.137071
v -644.890995 -708.138882 130.298369
v -381.583948 -812.204125 120.185107
v -297.464054 -709.281672 116.825699
v -1177.623603 292.207090 138.669007
v 622.439032 -328.741106 80.285646
v -1158.359845 66.590893 136.663783
v -198.496587 -598.415612 188.886468
v -96.435317 -431.900334 188.973548
v 143.844881 -115.818437 154.688601
v 412.339894 -371.475970 168.205263
v -195.200712 -593.242734 61.233643
v -72.400704 -392.245845 72.365325
v 133.756878 -77.549483 55.887476
v 456.027077 -441.221504 63.787272
v -1211.231277 292.435065 0.100322
v -1169.623814 64.675790 0.100152
v -1127.894660 -179.064676 0.100219
v -1043.228375 -431.045548 0.100188
v -869.911997 -604.592265 0.100015
v -657.874452 -720.597870 0.099989
v -374.572449 -847.076928 0.099862
v -304.684788 -713.330125 0.099919
v 974.854601 -178.474631 0.099891
v 1008.390541 -232.013952 0.099883
v -355.984634 959.738271 0.144634
v -15.764426 1005.934913 0.100318
v 739.069670 361.645665 0.099963
v 615.342669 476.350012 0.099888
v 738.006820 275.571170 0.099954
v 839.032145 77.584887 0.099927
v 1080.301879 -207.014622 0.099881
v 352.818592 868.738585 0.100280
v 431.019048 772.181761 0.100121
v 521.301533 611.975024 0.099765
v -1124.783042 452.987728 0.100381
v 175.994741 934.344381 0.100155
v -515.769889 895.372950 1.306213
v -953.799812 613.471111 0.102389
v 809.502526 -257.549898 0.022121
v 630.416151 -337.011218 0.135421
v -194.588642 -593.766981 0.099924
v -69.431029 -387.396031 -0.003012
v 133.756915 -77.549541 0.099957
v 463.660030 -453.407286 0.099943
v 634.164407 160.260594 -85.243509
v 687.580833 35.114190 -74.214137
v 627.881691 184.609761 -44.973268
v 734.710746 -22.641766 -46.269820
v 634.164392 160.260617 85.443546
v 687.580790 35.114079 74.414002
v 627.881715 184.609722 45.173226
v 734.710763 -22.641794 46.469715
v 633.888971 175.019283 0.099950
v 714.871580 9.030983 0.099928
v 301.384416 -282.346180 -121.275838
v 375.060253 -362.427807 -119.705716
v 251.514448 -197.387450 -81.089264
v 425.989929 -415.086002 -84.941576
v 301.384497 -282.346309 121.475808
v 375.060208 -362.427734 119.905481
v 251.514404 -197.387447 81.289238
v 425.989991 -415.086100 85.141375
v 238.371664 -175.224176 0.099987
v 407.907166 -382.313043 0.099859
v -143.460862 -88.723882 -737.748957
v -282.317966 63.402263 -779.889950
v -44.928200 -238.331358 -662.913437
v 67.366251 -282.134648 -526.683239
v 235.645229 -170.074319 -344.008904
v -533.619765 569.463122 -654.783370
v -461.287026 431.646883 -733.940126
v -381.597104 252.578978 -775.589485
v -546.145525 665.342991 -538.530962
v -652.808342 790.119857 -161.137432
v -664.780219 801.531532 -75.924340
v -627.307237 774.469915 -268.899479
v -586.634212 732.619660 -399.734311
v 261.676922 -212.514987 -172.749397
v -669.648256 805.215974 0.051083
v -143.455755 -88.735673 737.957620
v -282.320873 63.401156 780.108610
v -44.960767 -238.263735 663.199262
v 67.460470 -281.662161 527.719112
v 235.619042 -170.050926 344.207115
v -533.620295 569.463429 654.980872
v -461.179132 431.394194 734.280680
v -381.592958 252.563017 775.818568
v -546.156911 665.346976 538.726671
v -652.611478 790.345070 161.117273
v -664.765536 801.574968 76.379976
v -627.521160 774.187365 269.493780
v -586.658139 732.581641 399.987025
v 261.676893 -212.514941 172.949341
v -238.612791 -160.553663 -750.598191
v -119.702813 -308.180242 -660.369031
v -7.869788 -352.387904 -528.644467
v 147.371514 -188.049671 -350.225029
v -594.267490 533.235797 -663.516357
v -569.626852 372.829410 -745.310023
v -487.284785 190.283268 -788.385506
v -640.702345 614.230977 -545.176357
v -795.735549 704.315485 -161.577649
v -767.455913 690.796443 -271.594658
v -709.653769 659.704889 -405.703598
v 197.716898 -145.032209 -174.763345
v -238.607633 -160.555251 750.807430
v -119.705785 -308.221579 660.582860
v -8.894858 -353.569547 528.770732
v 147.360906 -188.049039 350.369491
v -594.267339 533.236365 663.713286
v -569.499015 372.861207 745.521543
v -487.137841 190.021188 788.668566
v -640.684642 614.288409 545.312554
v -795.736868 704.323160 161.806970
v -767.653734 690.719447 271.845350
v -709.762635 659.689515 405.848164
v 197.716907 -145.032223 174.963332
v -376.288504 3.076797 -786.114772
v -809.497916 714.305288 -73.447738
v -812.567513 719.202322 0.108304
v -376.361307 3.135356 786.376921
v -809.495294 714.309096 73.674789
v 626.651964 -176.639430 -581.762142
v 585.862417 -83.502501 -695.935809
v -47.420231 758.587267 -552.343808
v 25.522984 643.620921 -603.815020
v 107.034997 501.535317 -640.014802
v 205.255244 336.357723 -693.292312
v 345.144154 176.670563 -675.199551
v 503.116124 45.038861 -735.125648
v 734.517755 -181.242385 -384.333977
v 898.417710 -304.142659 -388.900926
v 1011.293532 -305.486260 -324.404423
v 1044.252306 -209.338332 -169.147649
v 1040.924871 -207.454857 -81.420962
v -155.691797 1013.130235 -62.738705
v -170.794610 926.027782 -331.859513
v -128.116183 857.415270 -459.944994
v -165.866757 1007.176131 -112.930102
v -173.533189 976.229098 -204.681018
v 1054.678229 -229.411762 0.099881
v -155.448287 1012.731597 0.100423
v 626.633324 -176.647399 581.951504
v 585.795997 -83.521591 696.111358
v -47.424123 758.580815 552.537860
v 25.510775 643.587504 603.977262
v 107.054113 501.266624 639.838446
v 205.255438 336.357413 684.571810
v 344.637200 176.543097 675.312286
v 502.890386 44.985683 735.267723
v 734.517918 -181.242645 384.533611
v 898.417821 -304.142837 389.100525
v 1011.293604 -305.486375 324.603994
v 1044.252404 -209.338488 169.347462
v 1040.924933 -207.454957 81.620773
v -155.691808 1013.130252 62.939167
v -170.809327 926.030167 332.056598
v -128.117103 857.414134 460.144632
v -165.866726 1007.176080 113.130670
v -173.534539 976.230580 204.881761
vt 0.766412 0.159661
vt 0.226630 0.104957
vt 0.724333 0.174523
vt 0.007263 0.168340
vt 0.661554 0.819049
vt 0.262846 0.092596
vt 0.585843 0.082800
vt 0.367912 0.426006
vt 0.892626 0.080395
vt 0.838557 0.489684
vt 0.441730 0.445879
vt 0.975972 0.154039
vt 0.683730 0.773620
vt 0.326524 0.270258
vt 0.441494 0.519422
vt 0.349718 0.810447
vt 0.330831 0.853484
vt 0.428868 0.861446
vt 0.954790 0.805177
vt 0.783868 0.380217
vt 0.724483 0.278268
vt 0.874812 0.224491
vt 0.286567 0.534941
vt 0.125300 0.821741
vt 0.290700 0.833429
vt 0.282697 0.511288
vt 0.287056 0.881648
vt 0.534196 0.482965
vt 0.186466 0.506181
vt 0.745993 0.557596
vt 0.783091 0.902413
vt 0.203148 0.428819
vt 0.632187 0.847417
vt 0.758618 0.599958
vt 0.259069 0.542795
vt 0.894065 0.531323
vt 0.415877 0.639865
vt 0.365194 0.482465
vt 0.950282 0.777010
vt 0.967962 0.731917
vt 0.569156 0.240814
vt 0.769147 0.893083
vt 0.766175 0.888515
vt 0.857813 0.582663
vt 0.237862 0.153778
vt 0.493762 0.255360
vt 0.306781 0.229820
vt 0.983608 0.241469
vt 0.330130 0.451897
vt 0.662887 0.847417
vt 0.502356 0.670695
vt 0.283215 0.495838
vt 0.724918 0.391826
vt 0.256627 0.761256
vt 0.702137 0.491365
vt 0.845233 0.302340
vt 0.711381 0.300663
vt 0.460604 0.748504
vt 0.380217 0.964448
vt 0.724779 0.194390
vt 0.489012 0.391349
vt 0.817453 0.595170
vt 0.884132 0.016777
vt 0.791881 0.545259
vt 0.780552 0.000320
vt 0.337680 0.344577
vt 0.665921 0.682442
vt 0.832885 0.221860
vt 0.656718 0.169021
vt 0.207504 0.231916
vt 0.770962 0.892947
vt 0.810420 0.586633
vt 0.769190 0.641241
vt 0.425781 0.351573
vt 0.336655 0.054873
vt 0.475824 0.260270
vt 0.769368 0.492442
vt 0.857902 0.551531
vt 0.299142 0.682106
vt 0.919027 0.771296
vt 0.826386 0.558371
vt 0.533817 0.500018
vt 0.942285 0.486510
vt 0.365702 0.515736
vt 0.394526 0.605633
vt 0.908106 0.819125
vt 0.674805 0.141705
vt 0.958200 0.607414
vt 0.879932 0.645883
vt 0.856956 0.697942
vt 0.772570 0.887791
vt 0.818772 0.183909
vt 0.977287 0.081051
vt 0.768059 0.895145
vt 0.666817 0.115828
vt 0.570000 0.165241
vt 0.781266 0.873291
vt 0.650204 0.922804
vt 0.439898 0.498780
vt 0.250093 0.514979
vt 0.480153 0.482779
vt 0.387585 0.247040
vt 0.439295 0.482399
vt 0.533928 0.465910
vt 0.186239 0.458693
vt 0.921485 0.782437
vt 0.650301 0.933557
vt 0.821047 0.579686
vt 0.058582 0.241893
vt 0.058577 0.312398
vt 0.150022 0.754814
vt 0.448534 0.100763
vt 0.947010 0.527711
vt 0.255786 0.656700
vt 0.317182 0.583485
vt 0.279479 0.625839
vt 0.918294 0.791394
vt 0.939132 0.567308
vt 0.485009 0.299470
vt 0.645037 0.342282
vt 0.731335 0.381565
vt 0.858389 0.388922
vt 0.157972 0.701861
vt 0.114620 0.349477
vt 0.676871 0.566754
vt 0.084060 0.372464
vt 0.821093 0.554392
vt 0.663895 0.858312
vt 0.367781 0.666765
vt 0.898383 0.279533
vt 0.244119 0.494936
vt 0.441893 0.423440
vt 0.684546 0.356990
vt 0.675826 0.550979
vt 0.861303 0.003694
vt 0.922822 0.777873
vt 0.902743 0.874193
vt 0.720639 0.452331
vt 0.817557 0.538880
vt 0.841585 0.055472
vt 0.891531 0.062872
vt 0.927355 0.468585
vt 0.663106 0.090134
vt 0.528180 0.745231
vt 0.203156 0.535593
vt 0.768056 0.893668
vt 0.618077 0.192790
vt 0.821768 0.197216
vt 0.719431 0.158666
vt 0.764226 0.145580
vt 0.191419 0.186262
vt 0.268830 0.139527
vt 0.853107 0.529627
vt 0.511324 0.338659
vt 0.543289 0.282968
vt 0.622745 0.524083
vt 0.663895 0.836522
vt 0.365037 0.497492
vt 0.551814 0.566725
vt 0.898960 0.567189
vt 0.664479 0.271483
vt 0.337480 0.533742
vt 0.766853 0.495664
vt 0.273304 0.394087
vt 0.183814 0.366574
vt 0.884511 0.655666
vt 0.280033 0.338455
vt 0.034676 0.251393
vt 0.083410 0.299273
vt 0.926832 0.665938
vt 0.898271 0.583433
vt 0.123076 0.279159
vt 0.984081 0.151534
vt 0.515674 0.786984
vt 0.744982 0.370189
vt 0.474536 0.704985
vt 0.400026 0.482566
vt 0.317614 0.381091
vt 0.347668 0.370388
vt 0.395198 0.359349
vt 0.288458 0.778915
vt 0.400292 0.498894
vt 0.976050 0.312217
vt 0.086208 0.810810
vt 0.115131 0.613947
vt 0.938795 0.050422
vt 0.645762 0.123563
vt 0.847277 0.089237
vt 0.848937 0.123892
vt 0.800028 0.086381
vt 0.087096 0.150850
vt 0.612121 0.107222
vt 0.515118 0.577331
vt 0.874996 0.166964
vt 0.218634 0.337761
vt 0.745588 0.495188
vt 0.614111 0.677787
vt 0.588500 0.593521
vt 0.756002 0.121772
vt 0.511735 0.345125
vt 0.981153 0.278269
vt 0.841781 0.405748
vt 0.791896 0.588681
vt 0.859215 0.567121
vt 0.400389 0.466164
vt 0.947366 0.549696
vt 0.930818 0.777569
vt 0.313489 0.791231
vt 0.913579 0.720133
vt 0.873921 0.748870
vt 0.905788 0.769456
vt 0.771586 0.897245
vt 0.524231 0.764210
vt 0.242504 0.469401
vt 0.988242 0.282801
vt 0.847510 0.267420
vt 0.318888 0.648566
vt 0.615000 0.216969
vt 0.693053 0.332334
vt 0.683618 0.193810
vt 0.719048 0.067546
vt 0.350136 0.260610
vt 0.536737 0.191378
vt 0.462500 0.923383
vt 0.947276 0.584961
vt 0.000201 0.790669
vt 0.730506 0.000201
vt 0.343174 0.400505
vt 0.456037 0.000201
vt 0.673272 0.245723
vt 0.106417 0.735766
vt 0.683593 0.176860
vt 0.660716 0.645496
vt 0.535671 0.161618
vt 0.380244 0.331737
vt 0.650204 0.772030
vt 0.633414 0.812674
vt 0.940055 0.354016
vt 0.774166 0.581798
vt 0.920217 0.780385
vt 0.723776 0.214238
vt 0.884956 0.478634
vt 0.827344 0.567053
vt 0.898341 0.550974
vt 0.304523 0.401565
vt 0.256438 0.307335
vt 0.299931 0.281892
vt 0.762914 0.922227
vt 0.677465 0.791062
vt 0.624264 0.648319
vt 0.891132 0.640371
vt 0.890727 0.008866
vt 0.736995 0.010055
vt 0.999799 0.840481
vt 0.330001 0.512866
vt 0.747233 0.539392
vt 0.808792 0.229640
vt 0.975495 0.238869
vt 0.571540 0.206864
vt 0.558046 0.538569
vt 0.092215 0.596728
vt 0.623580 0.580478
vt 0.491475 0.342405
vt 0.676417 0.375290
vt 0.367674 0.538904
vt 0.371516 0.395967
vt 0.400510 0.517510
vt 0.802435 0.037264
vt 0.025186 0.707123
vt 0.810835 0.915622
vt 0.826351 0.575729
vt 0.401990 0.423504
vt 0.803218 0.214247
vt 0.681324 0.222731
vt 0.977360 0.175031
vt 0.746841 0.842482
vt 0.524231 0.930624
vt 0.329045 0.469476
vt 0.920630 0.778625
vt 0.231573 0.691516
vt 0.336988 0.620116
vt 0.530132 0.513469
vt 0.655966 0.217800
vt 0.899226 0.787512
vt 0.666262 0.451048
vt 0.823572 0.675135
vt 0.649598 0.238407
vt 0.933245 0.787497
vt 0.258134 0.202418
vt 0.893817 0.603029
vt 0.817718 0.981205
vt 0.828311 0.086111
vt 0.148233 0.638486
vt 0.657850 0.193424
vt 0.133795 0.542450
vt 0.221618 0.399120
vt 0.761260 0.971528
vt 0.551814 0.572678
vt 0.459690 0.159496
vt 0.613352 0.125885
vt 0.774002 0.551778
vt 0.511492 0.811233
vt 0.564996 0.317339
vt 0.494154 0.429029
vt 0.449288 0.802291
vt 0.483862 0.665901
vt 0.190122 0.776639
vt 0.328991 0.495292
vt 0.379436 0.633120
vt 0.682441 0.013743
vt 0.511492 0.883601
vt 0.830422 0.003268
vt 0.857046 0.948766
vt 0.139070 0.548807
vt 0.351936 0.154058
vt 0.934348 0.604541
vt 0.441407 0.541984
vt 0.958410 0.527301
vt 0.863370 0.811804
vt 0.952204 0.567341
vt 0.936223 0.823205
vt 0.348924 0.703966
vt 0.332922 0.909206
vt 0.777093 0.391827
vt 0.899617 0.112648
vt 0.715634 0.932678
vt 0.569548 0.066755
vt 0.515765 0.388433
vt 0.150863 0.207852
vt 0.138386 0.415363
vt 0.946804 0.606942
vt 0.769722 0.896353
vt 0.819609 0.129213
vt 0.810223 0.161184
vt 0.286749 0.429617
vt 0.503577 0.294749
vt 0.445546 0.865459
vt 0.772889 0.896328
vt 0.775981 0.907003
vt 0.218340 0.626189
vt 0.657691 0.207453
vt 0.083814 0.663517
vt 0.977118 0.217834
vt 0.762845 0.244140
vt 0.763760 0.217065
vt 0.803687 0.195694
vt 0.989494 0.196484
vt 0.431898 0.104386
vt 0.461895 0.216735
vt 0.748377 0.022850
vt 0.000206 0.170384
vt 0.515674 0.907850
vt 0.492414 0.709921
vt 0.726649 0.110627
vt 0.290295 0.081970
vt 0.683730 0.921215
vt 0.923752 0.779693
vt 0.571437 0.271581
vt 0.623496 0.566743
vt 0.838225 0.644378
vt 0.162848 0.838910
vt 0.586487 0.556685
vt 0.635473 0.285572
vt 0.490544 0.623110
vt 0.106782 0.226652
vt 0.941853 0.648103
vt 0.701954 0.642178
vt 0.365866 0.449182
vt 0.509502 0.828214
vt 0.191578 0.449115
vt 0.765340 0.230155
vt 0.718932 0.249688
vt 0.290229 0.184966
vt 0.534599 0.221090
vt 0.646392 0.782365
vt 0.789342 0.116156
vt 0.952543 0.651391
vt 0.682043 0.933817
vt 0.762110 0.890356
vt 0.888145 0.383968
vt 0.611107 0.259621
vt 0.764774 0.194950
vt 0.754115 0.267768
vt 0.658121 0.179404
vt 0.675817 0.582520
vt 0.400761 0.447639
vt 0.595796 0.638752
vt 0.528180 0.949603
vt 0.714083 0.088065
vt 0.537497 0.135776
vt 0.790064 0.931130
vt 0.952996 0.483279
vt 0.402018 0.291046
vt 0.486995 0.449849
vt 0.880320 0.488401
vt 0.914915 0.781170
vt 0.206527 0.731395
vt 0.581952 0.301861
vt 0.486752 0.515725
vt 0.569381 0.635542
vt 0.746565 0.903208
vt 0.250109 0.449463
vt 0.365111 0.467431
vt 0.184766 0.663985
vt 0.572061 0.177143
vt 0.373374 0.363259
vt 0.400834 0.572258
vt 0.646392 0.912470
vt 0.924756 0.770836
vt 0.840978 0.728173
vt 0.650301 0.761277
vt 0.157061 0.394901
vt 0.425023 0.613573
vt 0.740077 0.338120
vt 0.345319 0.305959
vt 0.631079 0.862058
vt 0.696846 0.683468
vt 0.260517 0.870675
vt 0.758641 0.533700
vt 0.750075 0.884393
vt 0.640018 0.026788
vt 0.035623 0.795172
vt 0.415825 0.045449
vt 0.784238 0.054064
vt 0.743280 0.051324
vt 0.810475 0.547397
vt 0.941953 0.039134
vt 0.185099 0.299541
vt 0.546617 0.100184
vt 0.661554 0.875786
vt 0.818054 0.261651
vt 0.666489 0.608335
vt 0.622715 0.609395
vt 0.588513 0.539939
vt 0.914983 0.758531
vt 0.371093 0.568948
vt 0.763823 0.675884
vt 0.745451 0.638437
vt 0.969989 0.311577
vt 0.569401 0.497892
vt 0.273031 0.570338
vt 0.764115 0.457757
vt 0.831796 0.381599
vt 0.938867 0.583089
vt 0.861836 0.015174
vt 0.535481 0.247002
vt 0.633414 0.882160
vt 0.762325 0.876941
vt 0.643556 0.263040
vt 0.799090 0.354301
vt 0.891500 0.493975
vt 0.369749 0.764054
vt 0.884002 0.195894
vt 0.371450 0.200755
vt 0.881571 0.375921
vt 0.999231 0.783129
vt 0.927625 0.793763
vt 0.524037 0.426259
vt 0.631079 0.832776
vt 0.282921 0.482392
vt 0.614179 0.455650
vt 0.277809 0.719698
vt 0.777725 0.534060
vt 0.438378 0.390045
vt 0.827121 0.389147
vt 0.634211 0.360275
vt 0.599146 0.342552
vt 0.613605 0.326171
vt 0.936996 0.342623
vt 0.240838 0.482031
vt 0.574259 0.112572
vt 0.586479 0.566731
vt 0.782218 0.892764
vt 0.924585 0.476433
vt 0.327386 0.745020
vt 0.666551 0.525324
vt 0.638467 0.100905
vt 0.623584 0.552999
vt 0.934539 0.530047
vt 0.510789 0.620536
vt 0.838947 0.336340
vt 0.923238 0.782799
vt 0.224471 0.857921
vt 0.328912 0.219341
vt 0.810227 0.842482
vt 0.279055 0.244405
vt 0.804544 0.176735
vt 0.986625 0.174516
vt 0.510314 0.626952
vt 0.401317 0.392789
vt 0.344392 0.658635
vt 0.797566 0.304275
vt 0.833800 0.168321
vt 0.615802 0.168540
vt 0.747220 0.594261
vt 0.266645 0.823936
vt 0.853035 0.604665
vt 0.769576 0.566879
vt 0.333634 0.110717
vt 0.971252 0.081625
vt 0.604491 0.042984
vt 0.123014 0.683778
vt 0.650026 0.045030
vt 0.689869 0.032076
vt 0.696758 0.056664
vt 0.085002 0.590959
vt 0.693799 0.104002
vt 0.982011 0.114871
vt 0.571404 0.191996
vt 0.091385 0.366688
vt 0.811226 0.887105
vt 0.760769 0.895975
vt 0.777718 0.599693
vt 0.691297 0.284176
vt 0.826053 0.305170
vt 0.857607 0.436123
vt 0.938948 0.551525
vt 0.766681 0.638012
vt 0.386264 0.717803
vt 0.551814 0.560771
vt 0.958273 0.548119
vt 0.780936 0.336507
vt 0.866105 0.890766
vt 0.558040 0.594880
vt 0.682043 0.761017
vt 0.718442 0.229962
vt 0.249847 0.370777
vt 0.315457 0.172882
vt 0.894464 0.184000
vt 0.283273 0.468761
vt 0.133017 0.421769
vt 0.478132 0.754057
vt 0.924106 0.658080
vt 0.958174 0.586594
vt 0.772804 0.894528
vt 0.509502 0.866620
vt 0.304221 0.563015
vt 0.221530 0.565164
vt 0.894283 0.207836
vt 0.824040 0.458781
vt 0.481713 0.466925
vt 0.651003 0.148273
vt 0.148148 0.324964
vt 0.659939 0.297253
vt 0.293122 0.130305
vt 0.530331 0.452434
vt 0.677465 0.903772
vt 0.834996 0.010704
vt 0.126600 0.140201
vt 0.720442 0.138990
vt 0.617942 0.206107
vt 0.613212 0.235159
vt 0.986397 0.218450
vt 0.764467 0.172775
vt 0.337783 0.430735
vt 0.697403 0.450003
vt 0.989111 0.110435
vt 0.301331 0.599788
vt 0.816282 0.208160
vt 0.787432 0.274122
vt 0.523655 0.539598
vt 0.400951 0.673888
vt 0.595833 0.494690
vt 0.249551 0.593481
vt 0.916600 0.775009
vt 0.347144 0.594331
vt 0.259204 0.421646
vt 0.365440 0.630528
vt 0.007183 0.792757
vt 0.319678 0.315895
vt 0.536575 0.207653
vt 0.766511 0.903038
vt 0.416773 0.325190
vt 0.440183 0.465807
vt 0.488414 0.574232
vt 0.235999 0.809351
vt 0.157462 0.569146
vt 0.301815 0.364720
vt 0.164602 0.123274
vt 0.481562 0.498586
vt 0.401746 0.541505
vt 0.325440 0.694105
vt 0.451010 0.965923
vt 0.618223 0.059814
vt 0.058721 0.720239
vt 0.059287 0.650308
vt 0.035085 0.710614
vt 0.050465 0.645775
vt 0.035957 0.166156
vt 0.049639 0.316901
vt 0.024660 0.254831
vt 0.466701 0.043063
vt 0.569061 0.218697
vt 0.450321 0.163616
vt 0.232362 0.272204
vt 0.570877 0.143169
vt 0.305387 0.734377
vt 0.614624 0.150333
vt 0.586483 0.576777
vt 0.814501 0.567032
vt 0.372741 0.601618
vt 0.191720 0.515557
vt 0.981033 0.196439
vt 0.889541 0.329540
vt 0.715920 0.321409
vt 0.745898 0.566846
vt 0.493810 0.536624
vt 0.624325 0.485135
vt 0.609219 0.278305
vt 0.924341 0.781662
vt 0.582775 0.665752
vt 0.618381 0.179482
vt 0.787108 0.011786
vt 0.683097 0.210761
vt 0.183869 0.597368
vt 0.682168 0.164856
vt 0.479480 0.210989
vt 0.660806 0.487988
vt 0.921372 0.777644
vt 0.537161 0.175111
vt 0.342819 0.564308
vt 0.582813 0.467668
vt 0.329878 0.482390
vt 0.890876 0.311909
vt 0.859021 0.377312
vt 0.368746 0.297923
vt 0.282800 0.453305
vt 0.745989 0.576093
vt 0.366214 0.334252
vt 0.458955 0.806783
vt 0.720505 0.681366
vt 0.385081 0.000334
vt 0.934064 0.757947
vt 0.158417 0.261225
vt 0.712367 0.877212
vt 0.962419 0.567368
vt 0.961451 0.874193
vt 0.512994 0.847417
vt 0.437810 0.575240
vt 0.411716 0.920017
vn -0.066228 -0.305450 -0.949902
vn -0.225329 -0.610161 -0.759560
vn 0.371462 -0.402789 -0.836527
vn 0.267552 -0.134158 -0.954158
vn -0.245456 -0.896717 -0.368307
vn -0.565190 -0.689582 -0.452810
vn -0.687040 -0.725536 0.039675
vn -0.295443 -0.942066 -0.158821
vn -0.220476 -0.858821 -0.462403
vn 0.041781 -0.910857 -0.410603
vn -0.007174 -0.983037 -0.183266
vn 0.333742 -0.832007 -0.443148
vn -0.125749 0.762804 -0.634285
vn 0.026334 0.580084 -0.814131
vn -0.113773 0.595184 -0.795495
vn -0.256377 0.742646 -0.618667
vn 0.026334 0.580084 -0.814131
vn 0.134117 0.403185 -0.905237
vn 0.032466 0.386435 -0.921745
vn -0.113773 0.595184 -0.795495
vn 0.134117 0.403185 -0.905237
vn 0.139970 0.264999 -0.954036
vn 0.128478 0.206589 -0.969956
vn 0.032466 0.386435 -0.921745
vn 0.139970 0.264999 -0.954036
vn 0.061616 0.031104 -0.997615
vn 0.189351 0.053928 -0.980428
vn 0.128478 0.206589 -0.969956
vn 0.061616 0.031104 -0.997615
vn -0.066228 -0.305450 -0.949902
vn 0.267552 -0.134158 -0.954158
vn 0.189351 0.053928 -0.980428
vn -0.254097 -0.924209 -0.285083
vn -0.321707 -0.619862 -0.715735
vn 0.571352 -0.180100 -0.800700
vn 0.465841 -0.667296 -0.581126
vn -0.284230 0.908753 -0.305584
vn -0.250964 0.865827 -0.432852
vn -0.350999 0.822755 -0.447073
vn -0.394263 0.859921 -0.324179
vn 0.258891 0.452348 -0.853438
vn 0.158730 0.625316 -0.764058
vn 0.251084 0.642361 -0.724106
vn 0.408623 0.446022 -0.796298
vn 0.236124 0.382449 -0.893296
vn 0.258891 0.452348 -0.853438
vn 0.408623 0.446022 -0.796298
vn 0.470999 0.462086 -0.751423
vn 0.048591 0.128532 -0.990514
vn 0.236124 0.382449 -0.893296
vn 0.470999 0.462086 -0.751423
vn 0.361316 0.372891 -0.854636
vn -0.215143 -0.205056 -0.954812
vn 0.048591 0.128532 -0.990514
vn 0.361316 0.372891 -0.854636
vn 0.311951 0.453140 -0.835075
vn -0.340896 -0.228980 -0.911789
vn -0.215143 -0.205056 -0.954812
vn 0.311951 0.453140 -0.835075
vn 0.385559 0.265599 -0.883630
vn -0.225329 -0.610161 -0.759560
vn -0.220476 -0.858821 -0.462403
vn 0.333742 -0.832007 -0.443148
vn 0.371462 -0.402789 -0.836527
vn 0.361316 0.372891 -0.854636
vn 0.470999 0.462086 -0.751423
vn 0.934087 0.066695 -0.350760
vn 0.751453 0.619530 -0.226938
vn 0.311951 0.453140 -0.835075
vn 0.361316 0.372891 -0.854636
vn 0.751453 0.619530 -0.226938
vn 0.500773 0.826231 -0.258008
vn 0.385559 0.265599 -0.883630
vn 0.311951 0.453140 -0.835075
vn 0.500773 0.826231 -0.258008
vn 0.716831 0.554956 -0.422111
vn -0.321707 -0.619862 -0.715735
vn -0.340896 -0.228980 -0.911789
vn 0.385559 0.265599 -0.883630
vn 0.571352 -0.180100 -0.800700
vn 0.465841 -0.667296 -0.581126
vn 0.571352 -0.180100 -0.800700
vn 0.797849 0.200999 -0.568363
vn 0.076289 -0.713494 -0.696496
vn -0.320957 0.925361 -0.201729
vn -0.284230 0.908753 -0.305584
vn -0.394263 0.859921 -0.324179
vn -0.416788 0.877767 -0.236247
vn 0.408623 0.446022 -0.796298
vn 0.251084 0.642361 -0.724106
vn 0.351916 0.694101 -0.627996
vn 0.584972 0.388778 -0.711801
vn 0.470999 0.462086 -0.751423
vn 0.408623 0.446022 -0.796298
vn 0.584972 0.388778 -0.711801
vn 0.934087 0.066695 -0.350760
vn 0.076289 -0.713494 -0.696496
vn 0.797849 0.200999 -0.568363
vn 0.705115 0.301906 -0.641611
vn 0.152220 -0.401578 -0.903086
vn -0.250964 0.865827 -0.432852
vn -0.125749 0.762804 -0.634285
vn -0.256377 0.742646 -0.618667
vn -0.350999 0.822755 -0.447073
vn 0.584972 0.388778 -0.711801
vn 0.351916 0.694101 -0.627996
vn 0.475261 0.765488 -0.433768
vn 0.708330 0.431872 -0.558350
vn 0.934087 0.066695 -0.350760
vn 0.584972 0.388778 -0.711801
vn 0.708330 0.431872 -0.558350
vn 0.797406 -0.198153 -0.569982
vn 0.716831 0.554956 -0.422111
vn 0.500773 0.826231 -0.258008
vn 0.396877 0.839123 -0.371969
vn 0.731582 0.515831 -0.445765
vn 0.571352 -0.180100 -0.800700
vn 0.385559 0.265599 -0.883630
vn 0.716831 0.554956 -0.422111
vn 0.797849 0.200999 -0.568363
vn 0.934087 0.066695 -0.350760
vn 0.797406 -0.198153 -0.569982
vn 0.581213 -0.797729 -0.160684
vn 0.791387 -0.410996 0.452536
vn 0.731582 0.515831 -0.445765
vn 0.396877 0.839123 -0.371969
vn 0.470587 0.658381 -0.587437
vn 0.801184 0.479914 -0.357473
vn 0.500773 0.826231 -0.258008
vn 0.751453 0.619530 -0.226938
vn 0.717392 0.411943 0.561829
vn 0.356224 0.930220 0.088291
vn 0.797849 0.200999 -0.568363
vn 0.716831 0.554956 -0.422111
vn 0.731582 0.515831 -0.445765
vn 0.705115 0.301906 -0.641611
vn 0.152220 -0.401578 -0.903086
vn 0.705115 0.301906 -0.641611
vn 0.725541 0.494473 -0.478630
vn 0.890500 -0.199035 -0.409139
vn -0.326135 0.940076 -0.099463
vn -0.320957 0.925361 -0.201729
vn -0.416788 0.877767 -0.236247
vn -0.435528 0.890094 -0.134346
vn 0.708330 0.431872 -0.558350
vn 0.475261 0.765488 -0.433768
vn 0.512497 0.803799 -0.302082
vn 0.770556 0.467283 -0.433463
vn 0.797406 -0.198153 -0.569982
vn 0.708330 0.431872 -0.558350
vn 0.770556 0.467283 -0.433463
vn 0.690585 0.028480 -0.722690
vn -0.109918 0.940533 -0.321429
vn -0.070082 0.902745 -0.424428
vn -0.250964 0.865827 -0.432852
vn -0.284230 0.908753 -0.305584
vn 0.770556 0.467283 -0.433463
vn 0.512497 0.803799 -0.302082
vn 0.554930 0.813091 -0.175883
vn 0.818262 0.498354 -0.286515
vn 0.690585 0.028480 -0.722690
vn 0.770556 0.467283 -0.433463
vn 0.818262 0.498354 -0.286515
vn 0.831107 0.375388 -0.410299
vn 0.409886 0.321781 -0.853493
vn 0.690585 0.028480 -0.722690
vn 0.831107 0.375388 -0.410299
vn 0.624201 0.523979 -0.579499
vn 0.409886 0.321781 -0.853493
vn 0.470587 0.658381 -0.587437
vn 0.080385 0.655752 -0.750684
vn 0.111176 0.073924 -0.991048
vn 0.470587 0.658381 -0.587437
vn 0.409886 0.321781 -0.853493
vn 0.624201 0.523979 -0.579499
vn 0.720069 0.478765 -0.502280
vn 0.470587 0.658381 -0.587437
vn 0.396877 0.839123 -0.371969
vn 0.144947 0.940740 -0.306593
vn 0.080385 0.655752 -0.750684
vn 0.801184 0.479914 -0.357473
vn 0.470587 0.658381 -0.587437
vn 0.720069 0.478765 -0.502280
vn 0.956371 0.118435 0.267073
vn 0.797406 -0.198153 -0.569982
vn 0.690585 0.028480 -0.722690
vn 0.301752 -0.546247 -0.781383
vn 0.581213 -0.797729 -0.160684
vn 0.705115 0.301906 -0.641611
vn 0.731582 0.515831 -0.445765
vn 0.801184 0.479914 -0.357473
vn 0.725541 0.494473 -0.478630
vn 0.890500 -0.199035 -0.409139
vn 0.725541 0.494473 -0.478630
vn 0.625626 0.627937 0.462912
vn 0.987791 0.066625 -0.140817
vn 0.396877 0.839123 -0.371969
vn 0.500773 0.826231 -0.258008
vn 0.356224 0.930220 0.088291
vn 0.144947 0.940740 -0.306593
vn 0.214232 -0.953611 -0.211495
vn 0.236828 -0.847002 -0.475921
vn 0.802806 -0.596057 0.014802
vn 0.751784 -0.659210 -0.016205
vn -0.772501 0.532850 -0.345417
vn -0.693473 0.549724 -0.465724
vn -0.815569 0.253208 -0.520320
vn -0.910921 0.196330 -0.362874
vn 0.436518 -0.868331 0.235485
vn 0.362305 -0.921868 -0.137457
vn -0.404522 -0.914342 -0.018464
vn -0.212237 -0.920019 0.329424
vn -0.910921 0.196330 -0.362874
vn -0.815569 0.253208 -0.520320
vn -0.829216 -0.021145 -0.558528
vn -0.928281 -0.114703 -0.353749
vn -0.928281 -0.114703 -0.353749
vn -0.829216 -0.021145 -0.558528
vn -0.779127 -0.237781 -0.580019
vn -0.886024 -0.281948 -0.368057
vn -0.886024 -0.281948 -0.368057
vn -0.779127 -0.237781 -0.580019
vn -0.668381 -0.434650 -0.603611
vn -0.783771 -0.492739 -0.378037
vn -0.783771 -0.492739 -0.378037
vn -0.668381 -0.434650 -0.603611
vn -0.499063 -0.626879 -0.598297
vn -0.600060 -0.714308 -0.360128
vn 0.751453 0.619530 -0.226938
vn 0.934087 0.066695 -0.350760
vn 0.791387 -0.410996 0.452536
vn 0.717392 0.411943 0.561829
vn -0.600060 -0.714308 -0.360128
vn -0.499063 -0.626879 -0.598297
vn -0.289388 -0.710789 -0.641119
vn -0.421654 -0.839987 -0.341511
vn 0.690585 0.028480 -0.722690
vn 0.409886 0.321781 -0.853493
vn 0.111176 0.073924 -0.991048
vn 0.301752 -0.546247 -0.781383
vn 0.725541 0.494473 -0.478630
vn 0.801184 0.479914 -0.357473
vn 0.956371 0.118435 0.267073
vn 0.625626 0.627937 0.462912
vn -0.156244 -0.909439 0.385368
vn -0.212237 -0.920019 0.329424
vn -0.192025 -0.968323 0.159615
vn -0.128712 -0.965688 0.225567
vn 0.049529 -0.985673 -0.161234
vn -0.424941 -0.852560 0.304247
vn -0.156244 -0.909439 0.385368
vn -0.128712 -0.965688 0.225567
vn -0.033474 0.551846 -0.833274
vn 0.081311 0.938634 -0.335195
vn 0.406236 0.746930 -0.526373
vn 0.382236 0.548589 -0.743603
vn -0.254097 -0.924209 -0.285083
vn -0.285558 -0.954361 -0.087469
vn 0.049529 -0.985673 -0.161234
vn 0.041781 -0.910857 -0.410603
vn 0.834166 0.471655 0.285846
vn 0.976932 -0.190349 0.096807
vn 0.813776 0.262258 -0.518642
vn 0.702453 0.566331 -0.431078
vn -0.285558 -0.954361 -0.087469
vn -0.116996 -0.930308 -0.347618
vn -0.424941 -0.852560 0.304247
vn 0.049529 -0.985673 -0.161234
vn 0.976932 -0.190349 0.096807
vn 0.742188 -0.610824 -0.275772
vn 0.744860 0.048210 -0.665477
vn 0.813776 0.262258 -0.518642
vn -0.116996 -0.930308 -0.347618
vn 0.373747 -0.925881 -0.055301
vn -0.156244 -0.909439 0.385368
vn -0.424941 -0.852560 0.304247
vn 0.373747 -0.925881 -0.055301
vn 0.436518 -0.868331 0.235485
vn -0.212237 -0.920019 0.329424
vn -0.156244 -0.909439 0.385368
vn -0.212237 -0.920019 0.329424
vn -0.404522 -0.914342 -0.018464
vn -0.236954 -0.971225 0.023958
vn -0.192025 -0.968323 0.159615
vn 0.236828 -0.847002 -0.475921
vn 0.526374 -0.686725 -0.501337
vn 0.809259 -0.586580 0.032015
vn 0.802806 -0.596057 0.014802
vn -0.693473 0.549724 -0.465724
vn -0.615177 0.553343 -0.561577
vn -0.641728 0.359211 -0.677609
vn -0.815569 0.253208 -0.520320
vn -0.815569 0.253208 -0.520320
vn -0.641728 0.359211 -0.677609
vn -0.628630 0.108387 -0.770115
vn -0.829216 -0.021145 -0.558528
vn -0.829216 -0.021145 -0.558528
vn -0.628630 0.108387 -0.770115
vn -0.545796 -0.139666 -0.826196
vn -0.779127 -0.237781 -0.580019
vn -0.779127 -0.237781 -0.580019
vn -0.545796 -0.139666 -0.826196
vn -0.404478 -0.329162 -0.853259
vn -0.668381 -0.434650 -0.603611
vn -0.668381 -0.434650 -0.603611
vn -0.404478 -0.329162 -0.853259
vn -0.237993 -0.481862 -0.843308
vn -0.499063 -0.626879 -0.598297
vn 0.319358 -0.470005 -0.822864
vn 0.050741 0.003910 -0.998704
vn 0.457459 0.326659 -0.827058
vn 0.553540 0.097451 -0.827101
vn -0.499063 -0.626879 -0.598297
vn -0.237993 -0.481862 -0.843308
vn -0.020169 -0.542544 -0.839785
vn -0.289388 -0.710789 -0.641119
vn 0.050741 0.003910 -0.998704
vn -0.033474 0.551846 -0.833274
vn 0.382236 0.548589 -0.743603
vn 0.457459 0.326659 -0.827058
vn -0.421654 -0.839987 -0.341511
vn -0.289388 -0.710789 -0.641119
vn 0.236828 -0.847002 -0.475921
vn 0.214232 -0.953611 -0.211495
vn 0.742188 -0.610824 -0.275772
vn 0.319358 -0.470005 -0.822864
vn 0.553540 0.097451 -0.827101
vn 0.744860 0.048210 -0.665477
vn 0.352591 0.932810 0.074466
vn 0.834166 0.471655 0.285846
vn 0.702453 0.566331 -0.431078
vn 0.484577 0.753185 -0.444858
vn 0.081311 0.938634 -0.335195
vn 0.352591 0.932810 0.074466
vn 0.484577 0.753185 -0.444858
vn 0.406236 0.746930 -0.526373
vn 0.656739 0.344817 0.670667
vn 0.723071 -0.410120 0.555852
vn 0.976932 -0.190349 0.096807
vn 0.834166 0.471655 0.285846
vn -0.641728 0.359211 -0.677609
vn -0.478592 0.456650 -0.749947
vn -0.391023 0.226581 -0.892055
vn -0.628630 0.108387 -0.770115
vn -0.628630 0.108387 -0.770115
vn -0.391023 0.226581 -0.892055
vn -0.254665 -0.012086 -0.966954
vn -0.545796 -0.139666 -0.826196
vn -0.545796 -0.139666 -0.826196
vn -0.254665 -0.012086 -0.966954
vn -0.134657 -0.201492 -0.970190
vn -0.404478 -0.329162 -0.853259
vn -0.404478 -0.329162 -0.853259
vn -0.134657 -0.201492 -0.970190
vn -0.008650 -0.366333 -0.930444
vn -0.237993 -0.481862 -0.843308
vn -0.091292 0.621199 -0.778317
vn 0.018229 0.966214 -0.257096
vn 0.081311 0.938634 -0.335195
vn -0.033474 0.551846 -0.833274
vn -0.237993 -0.481862 -0.843308
vn -0.008650 -0.366333 -0.930444
vn 0.213798 -0.505002 -0.836220
vn -0.020169 -0.542544 -0.839785
vn 0.148955 -0.675379 -0.722271
vn -0.078937 -0.069684 -0.994441
vn 0.050741 0.003910 -0.998704
vn 0.319358 -0.470005 -0.822864
vn -0.289388 -0.710789 -0.641119
vn -0.020169 -0.542544 -0.839785
vn 0.526374 -0.686725 -0.501337
vn 0.236828 -0.847002 -0.475921
vn 0.723071 -0.410120 0.555852
vn 0.516662 -0.855998 0.018098
vn 0.742188 -0.610824 -0.275772
vn 0.976932 -0.190349 0.096807
vn 0.526374 -0.686725 -0.501337
vn 0.625951 -0.657175 -0.419888
vn 0.732799 -0.675004 0.085881
vn 0.809259 -0.586580 0.032015
vn -0.615177 0.553343 -0.561577
vn -0.516264 0.638676 -0.570582
vn -0.478592 0.456650 -0.749947
vn -0.641728 0.359211 -0.677609
vn 0.516662 -0.855998 0.018098
vn 0.148955 -0.675379 -0.722271
vn 0.319358 -0.470005 -0.822864
vn 0.742188 -0.610824 -0.275772
vn -0.078937 -0.069684 -0.994441
vn -0.091292 0.621199 -0.778317
vn -0.033474 0.551846 -0.833274
vn 0.050741 0.003910 -0.998704
vn 0.018229 0.966214 -0.257096
vn 0.289448 0.923009 0.253523
vn 0.352591 0.932810 0.074466
vn 0.081311 0.938634 -0.335195
vn -0.208992 0.596677 -0.774789
vn -0.113773 0.595184 -0.795495
vn 0.032466 0.386435 -0.921745
vn -0.030927 0.348852 -0.936667
vn -0.030927 0.348852 -0.936667
vn 0.032466 0.386435 -0.921745
vn 0.128478 0.206589 -0.969956
vn 0.077345 0.160587 -0.983987
vn 0.077345 0.160587 -0.983987
vn 0.128478 0.206589 -0.969956
vn 0.189351 0.053928 -0.980428
vn 0.161109 0.006277 -0.986917
vn 0.161109 0.006277 -0.986917
vn 0.189351 0.053928 -0.980428
vn 0.267552 -0.134158 -0.954158
vn 0.273801 -0.156959 -0.948893
vn 0.289448 0.923009 0.253523
vn 0.656739 0.344817 0.670667
vn 0.834166 0.471655 0.285846
vn 0.352591 0.932810 0.074466
vn 0.273801 -0.156959 -0.948893
vn 0.267552 -0.134158 -0.954158
vn 0.371462 -0.402789 -0.836527
vn 0.431551 -0.409088 -0.803997
vn 0.791387 -0.410996 0.452536
vn 0.581213 -0.797729 -0.160684
vn 0.516662 -0.855998 0.018098
vn 0.723071 -0.410120 0.555852
vn -0.020169 -0.542544 -0.839785
vn 0.213798 -0.505002 -0.836220
vn 0.625951 -0.657175 -0.419888
vn 0.526374 -0.686725 -0.501337
vn 0.356224 0.930220 0.088291
vn 0.717392 0.411943 0.561829
vn 0.656739 0.344817 0.670667
vn 0.289448 0.923009 0.253523
vn 0.550096 -0.787494 -0.277935
vn 0.333742 -0.832007 -0.443148
vn -0.007174 -0.983037 -0.183266
vn -0.222027 -0.974199 0.040499
vn -0.341444 0.749262 -0.567470
vn -0.256377 0.742646 -0.618667
vn -0.113773 0.595184 -0.795495
vn -0.208992 0.596677 -0.774789
vn 0.111176 0.073924 -0.991048
vn 0.080385 0.655752 -0.750684
vn -0.091292 0.621199 -0.778317
vn -0.078937 -0.069684 -0.994441
vn 0.080385 0.655752 -0.750684
vn 0.144947 0.940740 -0.306593
vn 0.018229 0.966214 -0.257096
vn -0.091292 0.621199 -0.778317
vn 0.581213 -0.797729 -0.160684
vn 0.301752 -0.546247 -0.781383
vn 0.148955 -0.675379 -0.722271
vn 0.516662 -0.855998 0.018098
vn 0.144947 0.940740 -0.306593
vn 0.356224 0.930220 0.088291
vn 0.289448 0.923009 0.253523
vn 0.018229 0.966214 -0.257096
vn 0.624201 0.523979 -0.579499
vn 0.831107 0.375388 -0.410299
vn 0.853092 0.478938 -0.207009
vn 0.723150 0.626073 -0.291697
vn 0.831107 0.375388 -0.410299
vn 0.818262 0.498354 -0.286515
vn 0.841040 0.532356 -0.096166
vn 0.853092 0.478938 -0.207009
vn 0.818262 0.498354 -0.286515
vn 0.554930 0.813091 -0.175883
vn 0.583011 0.811771 -0.033541
vn 0.841040 0.532356 -0.096166
vn -0.110494 0.992685 -0.048648
vn -0.132703 0.973275 -0.187416
vn -0.320957 0.925361 -0.201729
vn -0.326135 0.940076 -0.099463
vn 0.987791 0.066625 -0.140817
vn 0.625626 0.627937 0.462912
vn 0.482791 0.875389 -0.024659
vn 0.993642 0.010807 -0.112066
vn 0.717392 0.411943 0.561829
vn 0.791387 -0.410996 0.452536
vn 0.723071 -0.410120 0.555852
vn 0.656739 0.344817 0.670667
vn 0.956371 0.118435 0.267073
vn 0.720069 0.478765 -0.502280
vn 0.871784 0.431009 -0.232861
vn 0.954535 -0.297930 -0.010041
vn 0.301752 -0.546247 -0.781383
vn 0.111176 0.073924 -0.991048
vn -0.078937 -0.069684 -0.994441
vn 0.148955 -0.675379 -0.722271
vn 0.720069 0.478765 -0.502280
vn 0.624201 0.523979 -0.579499
vn 0.723150 0.626073 -0.291697
vn 0.871784 0.431009 -0.232861
vn -0.070082 0.902745 -0.424428
vn 0.026309 0.807735 -0.588959
vn -0.125749 0.762804 -0.634285
vn -0.250964 0.865827 -0.432852
vn 0.554930 0.813091 -0.175883
vn 0.329047 0.931632 -0.154242
vn 0.344578 0.937836 -0.041597
vn 0.583011 0.811771 -0.033541
vn -0.132703 0.973275 -0.187416
vn -0.109918 0.940533 -0.321429
vn -0.284230 0.908753 -0.305584
vn -0.320957 0.925361 -0.201729
vn 0.344578 0.937836 -0.041597
vn 0.329047 0.931632 -0.154242
vn 0.173112 0.965513 -0.194467
vn 0.213645 0.975495 -0.052585
vn 0.295838 0.922770 -0.246934
vn 0.249097 0.901190 -0.354694
vn 0.101579 0.909851 -0.402310
vn 0.141253 0.939127 -0.313191
vn 0.329047 0.931632 -0.154242
vn 0.295838 0.922770 -0.246934
vn 0.141253 0.939127 -0.313191
vn 0.173112 0.965513 -0.194467
vn 0.512497 0.803799 -0.302082
vn 0.295838 0.922770 -0.246934
vn 0.329047 0.931632 -0.154242
vn 0.554930 0.813091 -0.175883
vn 0.475261 0.765488 -0.433768
vn 0.249097 0.901190 -0.354694
vn 0.295838 0.922770 -0.246934
vn 0.512497 0.803799 -0.302082
vn 0.351916 0.694101 -0.627996
vn 0.193173 0.837898 -0.510500
vn 0.249097 0.901190 -0.354694
vn 0.475261 0.765488 -0.433768
vn 0.251084 0.642361 -0.724106
vn 0.131795 0.823256 -0.552159
vn 0.193173 0.837898 -0.510500
vn 0.351916 0.694101 -0.627996
vn 0.158730 0.625316 -0.764058
vn 0.026309 0.807735 -0.588959
vn 0.131795 0.823256 -0.552159
vn 0.251084 0.642361 -0.724106
vn 0.249097 0.901190 -0.354694
vn 0.193173 0.837898 -0.510500
vn 0.131795 0.823256 -0.552159
vn 0.101579 0.909851 -0.402310
vn -0.554303 0.822842 -0.125218
vn -0.539951 0.818324 -0.196973
vn -0.638294 0.740758 -0.209423
vn -0.640268 0.757648 -0.126595
vn -0.539951 0.818324 -0.196973
vn -0.512453 0.800066 -0.311907
vn -0.606709 0.734144 -0.304856
vn -0.638294 0.740758 -0.209423
vn -0.512453 0.800066 -0.311907
vn -0.471791 0.767922 -0.433254
vn -0.561441 0.711487 -0.422575
vn -0.606709 0.734144 -0.304856
vn -0.471791 0.767922 -0.433254
vn -0.425423 0.711144 -0.559723
vn -0.516264 0.638676 -0.570582
vn -0.561441 0.711487 -0.422575
vn -0.640268 0.757648 -0.126595
vn -0.638294 0.740758 -0.209423
vn -0.798088 0.549603 -0.246964
vn -0.793028 0.589486 -0.153663
vn -0.606709 0.734144 -0.304856
vn -0.561441 0.711487 -0.422575
vn -0.693473 0.549724 -0.465724
vn -0.772501 0.532850 -0.345417
vn -0.638294 0.740758 -0.209423
vn -0.606709 0.734144 -0.304856
vn -0.772501 0.532850 -0.345417
vn -0.798088 0.549603 -0.246964
vn -0.561441 0.711487 -0.422575
vn -0.516264 0.638676 -0.570582
vn -0.615177 0.553343 -0.561577
vn -0.693473 0.549724 -0.465724
vn 0.431551 -0.409088 -0.803997
vn 0.371462 -0.402789 -0.836527
vn 0.333742 -0.832007 -0.443148
vn 0.550096 -0.787494 -0.277935
vn -0.602361 -0.750068 -0.273056
vn -0.600060 -0.714308 -0.360128
vn -0.421654 -0.839987 -0.341511
vn -0.430430 -0.870475 -0.238753
vn -0.808332 -0.512336 -0.290020
vn -0.783771 -0.492739 -0.378037
vn -0.600060 -0.714308 -0.360128
vn -0.602361 -0.750068 -0.273056
vn -0.932002 -0.277831 -0.232768
vn -0.886024 -0.281948 -0.368057
vn -0.783771 -0.492739 -0.378037
vn -0.808332 -0.512336 -0.290020
vn -0.968258 -0.141874 -0.205789
vn -0.928281 -0.114703 -0.353749
vn -0.886024 -0.281948 -0.368057
vn -0.932002 -0.277831 -0.232768
vn -0.954760 0.168538 -0.245006
vn -0.910921 0.196330 -0.362874
vn -0.928281 -0.114703 -0.353749
vn -0.968258 -0.141874 -0.205789
vn -0.798088 0.549603 -0.246964
vn -0.772501 0.532850 -0.345417
vn -0.910921 0.196330 -0.362874
vn -0.954760 0.168538 -0.245006
vn 0.234823 -0.953715 -0.187843
vn 0.214232 -0.953611 -0.211495
vn 0.751784 -0.659210 -0.016205
vn 0.771016 -0.636792 -0.005585
vn 0.306694 -0.945660 -0.108008
vn 0.234823 -0.953715 -0.187843
vn 0.771016 -0.636792 -0.005585
vn 0.805223 -0.591984 -0.034212
vn -0.793028 0.589486 -0.153663
vn -0.798088 0.549603 -0.246964
vn -0.954760 0.168538 -0.245006
vn -0.973999 0.156705 -0.163612
vn -0.973999 0.156705 -0.163612
vn -0.954760 0.168538 -0.245006
vn -0.968258 -0.141874 -0.205789
vn -0.980534 -0.157699 -0.116980
vn -0.980534 -0.157699 -0.116980
vn -0.968258 -0.141874 -0.205789
vn -0.932002 -0.277831 -0.232768
vn -0.960810 -0.255003 -0.108708
vn -0.960810 -0.255003 -0.108708
vn -0.932002 -0.277831 -0.232768
vn -0.808332 -0.512336 -0.290020
vn -0.838255 -0.524022 -0.150764
vn -0.838255 -0.524022 -0.150764
vn -0.808332 -0.512336 -0.290020
vn -0.602361 -0.750068 -0.273056
vn -0.601253 -0.786107 -0.143288
vn -0.601253 -0.786107 -0.143288
vn -0.602361 -0.750068 -0.273056
vn -0.430430 -0.870475 -0.238753
vn -0.440971 -0.888995 -0.123419
vn -0.430430 -0.870475 -0.238753
vn -0.421654 -0.839987 -0.341511
vn 0.214232 -0.953611 -0.211495
vn 0.234823 -0.953715 -0.187843
vn -0.192025 -0.968323 0.159615
vn -0.236954 -0.971225 0.023958
vn 0.375750 -0.920966 -0.103123
vn 0.312513 -0.890035 -0.331923
vn -0.128712 -0.965688 0.225567
vn -0.192025 -0.968323 0.159615
vn 0.312513 -0.890035 -0.331923
vn 0.049529 -0.985673 -0.161234
vn 0.312513 -0.890035 -0.331923
vn 0.375750 -0.920966 -0.103123
vn 0.412311 -0.871828 -0.264417
vn 0.254526 -0.837424 -0.483671
vn 0.049529 -0.985673 -0.161234
vn 0.312513 -0.890035 -0.331923
vn 0.254526 -0.837424 -0.483671
vn 0.041781 -0.910857 -0.410603
vn 0.809259 -0.586580 0.032015
vn 0.732799 -0.675004 0.085881
vn 0.288046 -0.932438 0.218148
vn 0.821663 -0.566024 0.066990
vn 0.751784 -0.659210 -0.016205
vn 0.802806 -0.596057 0.014802
vn 0.815050 -0.578648 0.029329
vn 0.771016 -0.636792 -0.005585
vn -0.007174 -0.983037 -0.183266
vn 0.041781 -0.910857 -0.410603
vn 0.254526 -0.837424 -0.483671
vn -0.214140 -0.844541 -0.490809
vn 0.802806 -0.596057 0.014802
vn 0.809259 -0.586580 0.032015
vn 0.821663 -0.566024 0.066990
vn 0.815050 -0.578648 0.029329
vn -0.222027 -0.974199 0.040499
vn -0.007174 -0.983037 -0.183266
vn -0.214140 -0.844541 -0.490809
vn -0.687040 -0.725536 -0.039675
vn 0.815050 -0.578648 0.029329
vn 0.821663 -0.566024 0.066990
vn 0.835420 -0.547411 0.049136
vn 0.802001 -0.597321 0.001435
vn 0.821663 -0.566024 0.066990
vn 0.288046 -0.932438 0.218148
vn 0.126890 -0.986532 0.103215
vn 0.835420 -0.547411 0.049136
vn 0.771016 -0.636792 -0.005585
vn 0.815050 -0.578648 0.029329
vn 0.802001 -0.597321 0.001435
vn 0.805223 -0.591984 -0.034212
vn -0.214140 -0.844541 -0.490809
vn 0.254526 -0.837424 -0.483671
vn 0.412311 -0.871828 -0.264417
vn -0.111006 -0.964473 -0.239730
vn 0.375522 -0.900194 -0.220530
vn -0.295443 -0.942066 -0.158821
vn -0.687040 -0.725536 0.039675
vn -0.221234 -0.974410 -0.039766
vn 0.744860 0.048210 -0.665477
vn 0.553540 0.097451 -0.827101
vn 0.457459 0.326659 -0.827058
vn 0.813776 0.262258 -0.518642
vn 0.406236 0.746930 -0.526373
vn 0.813776 0.262258 -0.518642
vn 0.457459 0.326659 -0.827058
vn 0.382236 0.548589 -0.743603
vn 0.484577 0.753185 -0.444858
vn 0.702453 0.566331 -0.431078
vn 0.813776 0.262258 -0.518642
vn 0.406236 0.746930 -0.526373
vn 0.853092 0.478938 -0.207009
vn 0.841040 0.532356 -0.096166
vn 0.835654 0.549257 -0.000000
vn 0.861067 0.508492 0.000000
vn 0.344578 0.937836 -0.041597
vn 0.213645 0.975495 -0.052585
vn 0.202936 0.979192 -0.000000
vn 0.350487 0.936568 -0.000000
vn 0.841040 0.532356 -0.096166
vn 0.583011 0.811771 -0.033541
vn 0.578203 0.815893 -0.000000
vn 0.835654 0.549257 -0.000000
vn 0.805223 -0.591984 -0.034212
vn 0.802001 -0.597321 0.001435
vn 0.799357 -0.600857 0.000000
vn 0.818597 -0.574368 0.000000
vn 0.583011 0.811771 -0.033541
vn 0.344578 0.937836 -0.041597
vn 0.350487 0.936568 -0.000000
vn 0.578203 0.815893 -0.000000
vn 0.993642 0.010807 -0.112066
vn 0.482791 0.875389 -0.024659
vn 0.039541 0.999218 -0.000000
vn 0.985967 -0.166938 0.000000
vn -0.110494 0.992685 -0.048648
vn -0.326135 0.940076 -0.099463
vn -0.322412 0.946599 -0.001007
vn -0.111096 0.993810 -0.000000
vn 0.835420 -0.547411 0.049136
vn 0.126890 -0.986532 0.103215
vn 0.110662 -0.993858 0.000000
vn 0.844909 -0.534910 0.000000
vn -0.326135 0.940076 -0.099463
vn -0.435528 0.890094 -0.134346
vn -0.443339 0.896353 -0.001068
vn -0.322412 0.946599 -0.001007
vn 0.375750 -0.920966 -0.103123
vn -0.236954 -0.971225 0.023958
vn -0.283931 -0.958845 0.000000
vn 0.406636 -0.913590 -0.000091
vn -0.793028 0.589486 -0.153663
vn -0.973999 0.156705 -0.163612
vn -0.986495 0.160041 -0.034853
vn -0.796255 0.604866 -0.010682
vn 0.954535 -0.297930 -0.010041
vn 0.871784 0.431009 -0.232861
vn 0.933826 0.357728 0.000000
vn 0.874326 -0.485339 0.000000
vn -0.973999 0.156705 -0.163612
vn -0.980534 -0.157699 -0.116980
vn -0.985510 -0.167873 -0.024263
vn -0.986495 0.160041 -0.034853
vn -0.236954 -0.971225 0.023958
vn -0.404522 -0.914342 -0.018464
vn -0.390610 -0.920556 0.000000
vn -0.283931 -0.958845 0.000000
vn -0.980534 -0.157699 -0.116980
vn -0.960810 -0.255003 -0.108708
vn -0.969686 -0.244355 -0.000000
vn -0.985510 -0.167873 -0.024263
vn 0.871784 0.431009 -0.232861
vn 0.723150 0.626073 -0.291697
vn 0.742268 0.670103 -0.000000
vn 0.933826 0.357728 0.000000
vn 0.362305 -0.921868 -0.137457
vn 0.993642 0.010807 -0.112066
vn 0.985967 -0.166938 0.000000
vn 0.379652 -0.925129 0.000000
vn -0.111006 -0.964473 -0.239730
vn 0.412311 -0.871828 -0.264417
vn 0.475246 -0.879853 -0.000030
vn -0.072505 -0.997368 0.000000
vn -0.960810 -0.255003 -0.108708
vn -0.838255 -0.524022 -0.150764
vn -0.850183 -0.526487 -0.000000
vn -0.969686 -0.244355 -0.000000
vn -0.838255 -0.524022 -0.150764
vn -0.601253 -0.786107 -0.143288
vn -0.599883 -0.800088 0.000000
vn -0.850183 -0.526487 -0.000000
vn -0.601253 -0.786107 -0.143288
vn -0.440971 -0.888995 -0.123419
vn -0.444181 -0.895937 0.000000
vn -0.599883 -0.800088 0.000000
vn -0.640268 0.757648 -0.126595
vn -0.793028 0.589486 -0.153663
vn -0.796255 0.604866 -0.010682
vn -0.639929 0.768435 -0.000000
vn 0.802001 -0.597321 0.001435
vn 0.835420 -0.547411 0.049136
vn 0.844909 -0.534910 0.000000
vn 0.799357 -0.600857 0.000000
vn -0.440971 -0.888995 -0.123419
vn -0.430430 -0.870475 -0.238753
vn 0.234823 -0.953715 -0.187843
vn 0.306694 -0.945660 -0.108008
vn 0.412311 -0.871828 -0.264417
vn 0.375750 -0.920966 -0.103123
vn 0.406636 -0.913590 -0.000091
vn 0.475246 -0.879853 -0.000030
vn -0.554303 0.822842 -0.125218
vn -0.640268 0.757648 -0.126595
vn -0.639929 0.768435 -0.000000
vn -0.558560 0.829464 -0.000061
vn 0.723150 0.626073 -0.291697
vn 0.853092 0.478938 -0.207009
vn 0.861067 0.508492 0.000000
vn 0.742268 0.670103 -0.000000
vn -0.434895 0.890232 0.135474
vn -0.443339 0.896353 -0.001068
vn -0.511905 0.859042 -0.000824
vn -0.504933 0.852682 0.134072
vn 0.306694 -0.945660 -0.108008
vn 0.805223 -0.591984 -0.034212
vn 0.818597 -0.574368 0.000000
vn 0.328481 -0.944511 0.000000
vn -0.051775 -0.288512 0.956075
vn 0.267661 -0.134048 0.954143
vn 0.371482 -0.402017 0.836889
vn -0.225369 -0.610332 0.759411
vn -0.440971 -0.888995 -0.123419
vn 0.306694 -0.945660 -0.108008
vn 0.328481 -0.944511 0.000000
vn -0.444181 -0.895937 0.000000
vn -0.220417 -0.858854 0.462371
vn 0.333185 -0.832380 0.442868
vn -0.008404 -0.983101 0.182872
vn 0.041707 -0.910803 0.410729
vn -0.125733 0.762780 0.634317
vn -0.256345 0.742644 0.618682
vn -0.113729 0.595166 0.795514
vn 0.026434 0.580038 0.814160
vn 0.026434 0.580038 0.814160
vn -0.113729 0.595166 0.795514
vn 0.032584 0.386467 0.921727
vn 0.134975 0.403070 0.905161
vn 0.134975 0.403070 0.905161
vn 0.032584 0.386467 0.921727
vn 0.128690 0.206649 0.969915
vn 0.159549 0.271285 0.949183
vn 0.159549 0.271285 0.949183
vn 0.128690 0.206649 0.969915
vn 0.189464 0.054035 0.980400
vn 0.099142 0.055763 0.993510
vn 0.099142 0.055763 0.993510
vn 0.189464 0.054035 0.980400
vn 0.267661 -0.134048 0.954143
vn -0.051775 -0.288512 0.956075
vn -0.254037 -0.924236 0.285050
vn 0.465971 -0.667101 0.581246
vn 0.571472 -0.178733 0.800921
vn -0.321554 -0.619849 0.715815
vn -0.283772 0.908781 0.305927
vn -0.394052 0.859754 0.324878
vn -0.350978 0.822718 0.447158
vn -0.250842 0.865813 0.432951
vn 0.259578 0.451773 0.853534
vn 0.409605 0.444877 0.796435
vn 0.251306 0.642174 0.724195
vn 0.158885 0.625222 0.764103
vn 0.228333 0.377065 0.897600
vn 0.490451 0.447116 0.748028
vn 0.409605 0.444877 0.796435
vn 0.259578 0.451773 0.853534
vn 0.024368 0.121499 0.992292
vn 0.354973 0.338632 0.871391
vn 0.490451 0.447116 0.748028
vn 0.228333 0.377065 0.897600
vn -0.247065 -0.229013 0.941548
vn 0.317386 0.507855 0.800843
vn 0.354973 0.338632 0.871391
vn 0.024368 0.121499 0.992292
vn -0.340990 -0.229110 0.911720
vn 0.385338 0.269746 0.882469
vn 0.317386 0.507855 0.800843
vn -0.247065 -0.229013 0.941548
vn -0.225369 -0.610332 0.759411
vn 0.371482 -0.402017 0.836889
vn 0.333185 -0.832380 0.442868
vn -0.220417 -0.858854 0.462371
vn 0.354973 0.338632 0.871391
vn 0.759762 0.638783 0.121315
vn 0.939970 0.049176 0.337694
vn 0.490451 0.447116 0.748028
vn 0.317386 0.507855 0.800843
vn 0.491617 0.835831 0.244333
vn 0.759762 0.638783 0.121315
vn 0.354973 0.338632 0.871391
vn 0.385338 0.269746 0.882469
vn 0.713393 0.558673 0.423030
vn 0.491617 0.835831 0.244333
vn 0.317386 0.507855 0.800843
vn -0.321554 -0.619849 0.715815
vn 0.571472 -0.178733 0.800921
vn 0.385338 0.269746 0.882469
vn -0.340990 -0.229110 0.911720
vn 0.465971 -0.667101 0.581246
vn 0.076271 -0.713304 0.696693
vn 0.797158 0.201755 0.569064
vn 0.571472 -0.178733 0.800921
vn -0.319558 0.925604 0.202830
vn -0.416376 0.877284 0.238753
vn -0.394052 0.859754 0.324878
vn -0.283772 0.908781 0.305927
vn 0.409605 0.444877 0.796435
vn 0.585269 0.387380 0.712318
vn 0.352015 0.693847 0.628220
vn 0.251306 0.642174 0.724195
vn 0.490451 0.447116 0.748028
vn 0.939970 0.049176 0.337694
vn 0.585269 0.387380 0.712318
vn 0.409605 0.444877 0.796435
vn 0.076271 -0.713304 0.696693
vn 0.152161 -0.401541 0.903112
vn 0.704444 0.301991 0.642309
vn 0.797158 0.201755 0.569064
vn -0.250842 0.865813 0.432951
vn -0.350978 0.822718 0.447158
vn -0.256345 0.742644 0.618682
vn -0.125733 0.762780 0.634317
vn 0.585269 0.387380 0.712318
vn 0.708181 0.431202 0.559057
vn 0.475276 0.765356 0.433984
vn 0.352015 0.693847 0.628220
vn 0.939970 0.049176 0.337694
vn 0.796544 -0.198751 0.570978
vn 0.708181 0.431202 0.559057
vn 0.585269 0.387380 0.712318
vn 0.713393 0.558673 0.423030
vn 0.729456 0.516913 0.447990
vn 0.393187 0.839257 0.375568
vn 0.491617 0.835831 0.244333
vn 0.571472 -0.178733 0.800921
vn 0.797158 0.201755 0.569064
vn 0.713393 0.558673 0.423030
vn 0.385338 0.269746 0.882469
vn 0.939970 0.049176 0.337694
vn 0.796620 -0.412955 -0.441434
vn 0.581022 -0.797770 0.161172
vn 0.796544 -0.198751 0.570978
vn 0.729456 0.516913 0.447990
vn 0.800842 0.480168 0.357899
vn 0.470022 0.658242 0.588044
vn 0.393187 0.839257 0.375568
vn 0.491617 0.835831 0.244333
vn 0.350418 0.934726 -0.059115
vn 0.730667 0.419575 -0.538592
vn 0.759762 0.638783 0.121315
vn 0.797158 0.201755 0.569064
vn 0.704444 0.301991 0.642309
vn 0.729456 0.516913 0.447990
vn 0.713393 0.558673 0.423030
vn 0.152161 -0.401541 0.903112
vn 0.890490 -0.199010 0.409172
vn 0.725445 0.494522 0.478725
vn 0.704444 0.301991 0.642309
vn -0.324433 0.940684 0.099277
vn -0.434895 0.890232 0.135474
vn -0.416376 0.877284 0.238753
vn -0.319558 0.925604 0.202830
vn 0.708181 0.431202 0.559057
vn 0.770534 0.467126 0.433672
vn 0.512515 0.803776 0.302113
vn 0.475276 0.765356 0.433984
vn 0.796544 -0.198751 0.570978
vn 0.690462 0.028441 0.722809
vn 0.770534 0.467126 0.433672
vn 0.708181 0.431202 0.559057
vn -0.109808 0.940534 0.321461
vn -0.283772 0.908781 0.305927
vn -0.250842 0.865813 0.432951
vn -0.070041 0.902746 0.424433
vn 0.770534 0.467126 0.433672
vn 0.818271 0.498323 0.286543
vn 0.554927 0.813087 0.175913
vn 0.512515 0.803776 0.302113
vn 0.690462 0.028441 0.722809
vn 0.831086 0.375341 0.410385
vn 0.818271 0.498323 0.286543
vn 0.770534 0.467126 0.433672
vn 0.409761 0.321631 0.853610
vn 0.624154 0.523912 0.579611
vn 0.831086 0.375341 0.410385
vn 0.690462 0.028441 0.722809
vn 0.409761 0.321631 0.853610
vn 0.111119 0.073780 0.991064
vn 0.080181 0.655153 0.751229
vn 0.470022 0.658242 0.588044
vn 0.470022 0.658242 0.588044
vn 0.720004 0.478725 0.502411
vn 0.624154 0.523912 0.579611
vn 0.409761 0.321631 0.853610
vn 0.470022 0.658242 0.588044
vn 0.080181 0.655153 0.751229
vn 0.143991 0.939573 0.310594
vn 0.393187 0.839257 0.375568
vn 0.800842 0.480168 0.357899
vn 0.956395 0.118451 -0.266981
vn 0.720004 0.478725 0.502411
vn 0.470022 0.658242 0.588044
vn 0.796544 -0.198751 0.570978
vn 0.581022 -0.797770 0.161172
vn 0.301680 -0.546190 0.781451
vn 0.690462 0.028441 0.722809
vn 0.704444 0.301991 0.642309
vn 0.725445 0.494522 0.478725
vn 0.800842 0.480168 0.357899
vn 0.729456 0.516913 0.447990
vn 0.890490 -0.199010 0.409172
vn 0.987791 0.066625 0.140817
vn 0.625615 0.627967 -0.462885
vn 0.725445 0.494522 0.478725
vn 0.393187 0.839257 0.375568
vn 0.143991 0.939573 0.310594
vn 0.350418 0.934726 -0.059115
vn 0.491617 0.835831 0.244333
vn 0.214234 -0.953624 0.211437
vn 0.751786 -0.659212 0.016084
vn 0.802778 -0.596085 -0.015168
vn 0.236782 -0.847101 0.475768
vn -0.772674 0.532716 0.345237
vn -0.910958 0.196272 0.362813
vn -0.815606 0.253130 0.520300
vn -0.693603 0.549307 0.466023
vn 0.436518 -0.868331 -0.235485
vn -0.212237 -0.920019 -0.329424
vn -0.404522 -0.914342 0.018464
vn 0.362305 -0.921868 0.137457
vn -0.910958 0.196272 0.362813
vn -0.928281 -0.114703 0.353749
vn -0.829230 -0.021145 0.558507
vn -0.815606 0.253130 0.520300
vn -0.928281 -0.114703 0.353749
vn -0.886044 -0.281923 0.368028
vn -0.779127 -0.237781 0.580019
vn -0.829230 -0.021145 0.558507
vn -0.886044 -0.281923 0.368028
vn -0.783771 -0.492739 0.378037
vn -0.668403 -0.434663 0.603577
vn -0.779127 -0.237781 0.580019
vn -0.783771 -0.492739 0.378037
vn -0.600060 -0.714308 0.360129
vn -0.499063 -0.626879 0.598297
vn -0.668403 -0.434663 0.603577
vn 0.759762 0.638783 0.121315
vn 0.730667 0.419575 -0.538592
vn 0.796620 -0.412955 -0.441434
vn 0.939970 0.049176 0.337694
vn -0.600060 -0.714308 0.360129
vn -0.421654 -0.839987 0.341511
vn -0.289454 -0.710792 0.641085
vn -0.499063 -0.626879 0.598297
vn 0.690462 0.028441 0.722809
vn 0.301680 -0.546190 0.781451
vn 0.111119 0.073780 0.991064
vn 0.409761 0.321631 0.853610
vn 0.725445 0.494522 0.478725
vn 0.625615 0.627967 -0.462885
vn 0.956395 0.118451 -0.266981
vn 0.800842 0.480168 0.357899
vn -0.156244 -0.909439 -0.385368
vn -0.128669 -0.965694 -0.225566
vn -0.191960 -0.968331 -0.159647
vn -0.212237 -0.920019 -0.329424
vn 0.049690 -0.985640 0.161386
vn -0.128669 -0.965694 -0.225566
vn -0.156244 -0.909439 -0.385368
vn -0.424941 -0.852560 -0.304247
vn -0.033334 0.551678 0.833391
vn 0.382236 0.548589 0.743603
vn 0.406229 0.746918 0.526395
vn 0.081564 0.938294 0.336082
vn -0.254037 -0.924236 0.285050
vn 0.041707 -0.910803 0.410729
vn 0.049690 -0.985640 0.161386
vn -0.285536 -0.954365 0.087498
vn 0.834655 0.471494 -0.284684
vn 0.702453 0.566331 0.431078
vn 0.813776 0.262258 0.518642
vn 0.976945 -0.190528 -0.096320
vn -0.285536 -0.954365 0.087498
vn 0.049690 -0.985640 0.161386
vn -0.424941 -0.852560 -0.304247
vn -0.116996 -0.930308 0.347618
vn 0.976945 -0.190528 -0.096320
vn 0.813776 0.262258 0.518642
vn 0.744860 0.048210 0.665477
vn 0.742157 -0.610836 0.275831
vn -0.116996 -0.930308 0.347618
vn -0.424941 -0.852560 -0.304247
vn -0.156244 -0.909439 -0.385368
vn 0.373747 -0.925881 0.055301
vn 0.373747 -0.925881 0.055301
vn -0.156244 -0.909439 -0.385368
vn -0.212237 -0.920019 -0.329424
vn 0.436518 -0.868331 -0.235485
vn -0.212237 -0.920019 -0.329424
vn -0.191960 -0.968331 -0.159647
vn -0.236912 -0.971233 -0.024049
vn -0.404522 -0.914342 0.018464
vn 0.236782 -0.847101 0.475768
vn 0.802778 -0.596085 -0.015168
vn 0.809284 -0.586528 -0.032319
vn 0.526215 -0.687046 0.501065
vn -0.693603 0.549307 0.466023
vn -0.815606 0.253130 0.520300
vn -0.641726 0.359146 0.677644
vn -0.615169 0.553088 0.561837
vn -0.815606 0.253130 0.520300
vn -0.829230 -0.021145 0.558507
vn -0.628573 0.108462 0.770151
vn -0.641726 0.359146 0.677644
vn -0.829230 -0.021145 0.558507
vn -0.779127 -0.237781 0.580019
vn -0.546047 -0.139607 0.826041
vn -0.628573 0.108462 0.770151
vn -0.779127 -0.237781 0.580019
vn -0.668403 -0.434663 0.603577
vn -0.404567 -0.329469 0.853098
vn -0.546047 -0.139607 0.826041
vn -0.668403 -0.434663 0.603577
vn -0.499063 -0.626879 0.598297
vn -0.237963 -0.481918 0.843285
vn -0.404567 -0.329469 0.853098
vn 0.319369 -0.470023 0.822850
vn 0.553540 0.097451 0.827101
vn 0.457458 0.326660 0.827058
vn 0.050782 0.003900 0.998702
vn -0.499063 -0.626879 0.598297
vn -0.289454 -0.710792 0.641085
vn -0.020548 -0.542464 0.839828
vn -0.237963 -0.481918 0.843285
vn 0.050782 0.003900 0.998702
vn 0.457458 0.326660 0.827058
vn 0.382236 0.548589 0.743603
vn -0.033334 0.551678 0.833391
vn -0.421654 -0.839987 0.341511
vn 0.214234 -0.953624 0.211437
vn 0.236782 -0.847101 0.475768
vn -0.289454 -0.710792 0.641085
vn 0.742157 -0.610836 0.275831
vn 0.744860 0.048210 0.665477
vn 0.553540 0.097451 0.827101
vn 0.319369 -0.470023 0.822850
vn 0.352769 0.932899 -0.072484
vn 0.484577 0.753185 0.444858
vn 0.702453 0.566331 0.431078
vn 0.834655 0.471494 -0.284684
vn 0.081564 0.938294 0.336082
vn 0.406229 0.746918 0.526395
vn 0.484577 0.753185 0.444858
vn 0.352769 0.932899 -0.072484
vn 0.659520 0.345696 -0.667479
vn 0.834655 0.471494 -0.284684
vn 0.976945 -0.190528 -0.096320
vn 0.723557 -0.410672 -0.554809
vn -0.641726 0.359146 0.677644
vn -0.628573 0.108462 0.770151
vn -0.391035 0.226604 0.892044
vn -0.478581 0.456742 0.749898
vn -0.628573 0.108462 0.770151
vn -0.546047 -0.139607 0.826041
vn -0.254228 -0.012674 0.967061
vn -0.391035 0.226604 0.892044
vn -0.546047 -0.139607 0.826041
vn -0.404567 -0.329469 0.853098
vn -0.134474 -0.201558 0.970201
vn -0.254228 -0.012674 0.967061
vn -0.404567 -0.329469 0.853098
vn -0.237963 -0.481918 0.843285
vn -0.008708 -0.366291 0.930460
vn -0.134474 -0.201558 0.970201
vn -0.091096 0.620718 0.778723
vn -0.033334 0.551678 0.833391
vn 0.081564 0.938294 0.336082
vn 0.018369 0.965476 0.259843
vn -0.237963 -0.481918 0.843285
vn -0.020548 -0.542464 0.839828
vn 0.213577 -0.504824 0.836383
vn -0.008708 -0.366291 0.930460
vn 0.148978 -0.675353 0.722291
vn 0.319369 -0.470023 0.822850
vn 0.050782 0.003900 0.998702
vn -0.078870 -0.069677 0.994447
vn -0.289454 -0.710792 0.641085
vn 0.236782 -0.847101 0.475768
vn 0.526215 -0.687046 0.501065
vn -0.020548 -0.542464 0.839828
vn 0.723557 -0.410672 -0.554809
vn 0.976945 -0.190528 -0.096320
vn 0.742157 -0.610836 0.275831
vn 0.516636 -0.856015 -0.018067
vn 0.526215 -0.687046 0.501065
vn 0.809284 -0.586528 -0.032319
vn 0.732898 -0.674873 -0.086064
vn 0.625744 -0.656851 0.420703
vn -0.615169 0.553088 0.561837
vn -0.641726 0.359146 0.677644
vn -0.478581 0.456742 0.749898
vn -0.516111 0.638603 0.570802
vn 0.516636 -0.856015 -0.018067
vn 0.742157 -0.610836 0.275831
vn 0.319369 -0.470023 0.822850
vn 0.148978 -0.675353 0.722291
vn -0.078870 -0.069677 0.994447
vn 0.050782 0.003900 0.998702
vn -0.033334 0.551678 0.833391
vn -0.091096 0.620718 0.778723
vn 0.018369 0.965476 0.259843
vn 0.081564 0.938294 0.336082
vn 0.352769 0.932899 -0.072484
vn 0.289513 0.925027 -0.245984
vn -0.209019 0.596664 0.774793
vn -0.030771 0.348657 0.936745
vn 0.032584 0.386467 0.921727
vn -0.113729 0.595166 0.795514
vn -0.030771 0.348657 0.936745
vn 0.077449 0.160654 0.983968
vn 0.128690 0.206649 0.969915
vn 0.032584 0.386467 0.921727
vn 0.077449 0.160654 0.983968
vn 0.161312 0.006297 0.986883
vn 0.189464 0.054035 0.980400
vn 0.128690 0.206649 0.969915
vn 0.161312 0.006297 0.986883
vn 0.273836 -0.156901 0.948892
vn 0.267661 -0.134048 0.954143
vn 0.189464 0.054035 0.980400
vn 0.289513 0.925027 -0.245984
vn 0.352769 0.932899 -0.072484
vn 0.834655 0.471494 -0.284684
vn 0.659520 0.345696 -0.667479
vn 0.273836 -0.156901 0.948892
vn 0.431132 -0.408767 0.804385
vn 0.371482 -0.402017 0.836889
vn 0.267661 -0.134048 0.954143
vn 0.796620 -0.412955 -0.441434
vn 0.723557 -0.410672 -0.554809
vn 0.516636 -0.856015 -0.018067
vn 0.581022 -0.797770 0.161172
vn -0.020548 -0.542464 0.839828
vn 0.526215 -0.687046 0.501065
vn 0.625744 -0.656851 0.420703
vn 0.213577 -0.504824 0.836383
vn 0.350418 0.934726 -0.059115
vn 0.289513 0.925027 -0.245984
vn 0.659520 0.345696 -0.667479
vn 0.730667 0.419575 -0.538592
vn 0.551728 -0.784464 0.283218
vn -0.221234 -0.974410 -0.039766
vn -0.008404 -0.983101 0.182872
vn 0.333185 -0.832380 0.442868
vn -0.341444 0.749262 0.567470
vn -0.209019 0.596664 0.774793
vn -0.113729 0.595166 0.795514
vn -0.256345 0.742644 0.618682
vn 0.111119 0.073780 0.991064
vn -0.078870 -0.069677 0.994447
vn -0.091096 0.620718 0.778723
vn 0.080181 0.655153 0.751229
vn 0.080181 0.655153 0.751229
vn -0.091096 0.620718 0.778723
vn 0.018369 0.965476 0.259843
vn 0.143991 0.939573 0.310594
vn 0.581022 -0.797770 0.161172
vn 0.516636 -0.856015 -0.018067
vn 0.148978 -0.675353 0.722291
vn 0.301680 -0.546190 0.781451
vn 0.143991 0.939573 0.310594
vn 0.018369 0.965476 0.259843
vn 0.289513 0.925027 -0.245984
vn 0.350418 0.934726 -0.059115
vn 0.624154 0.523912 0.579611
vn 0.723145 0.626075 0.291706
vn 0.853086 0.478933 0.207044
vn 0.831086 0.375341 0.410385
vn 0.831086 0.375341 0.410385
vn 0.853086 0.478933 0.207044
vn 0.841040 0.532356 0.096166
vn 0.818271 0.498323 0.286543
vn 0.818271 0.498323 0.286543
vn 0.841040 0.532356 0.096166
vn 0.583011 0.811771 0.033571
vn 0.554927 0.813087 0.175913
vn -0.110440 0.992693 0.048616
vn -0.324433 0.940684 0.099277
vn -0.319558 0.925604 0.202830
vn -0.132596 0.973290 0.187419
vn 0.987791 0.066625 0.140817
vn 0.993642 0.010807 0.112066
vn 0.482791 0.875389 0.024659
vn 0.625615 0.627967 -0.462885
vn 0.730667 0.419575 -0.538592
vn 0.659520 0.345696 -0.667479
vn 0.723557 -0.410672 -0.554809
vn 0.796620 -0.412955 -0.441434
vn 0.956395 0.118451 -0.266981
vn 0.954535 -0.297930 0.010041
vn 0.871784 0.431009 0.232861
vn 0.720004 0.478725 0.502411
vn 0.301680 -0.546190 0.781451
vn 0.148978 -0.675353 0.722291
vn -0.078870 -0.069677 0.994447
vn 0.111119 0.073780 0.991064
vn 0.720004 0.478725 0.502411
vn 0.871784 0.431009 0.232861
vn 0.723145 0.626075 0.291706
vn 0.624154 0.523912 0.579611
vn -0.070041 0.902746 0.424433
vn -0.250842 0.865813 0.432951
vn -0.125733 0.762780 0.634317
vn 0.026350 0.807716 0.588983
vn 0.554927 0.813087 0.175913
vn 0.583011 0.811771 0.033571
vn 0.344578 0.937836 0.041597
vn 0.329047 0.931632 0.154242
vn -0.132596 0.973290 0.187419
vn -0.319558 0.925604 0.202830
vn -0.283772 0.908781 0.305927
vn -0.109808 0.940534 0.321461
vn 0.344578 0.937836 0.041597
vn 0.213645 0.975495 0.052584
vn 0.173112 0.965513 0.194467
vn 0.329047 0.931632 0.154242
vn 0.295838 0.922770 0.246934
vn 0.141253 0.939127 0.313191
vn 0.101577 0.909840 0.402336
vn 0.249112 0.901162 0.354754
vn 0.329047 0.931632 0.154242
vn 0.173112 0.965513 0.194467
vn 0.141253 0.939127 0.313191
vn 0.295838 0.922770 0.246934
vn 0.512515 0.803776 0.302113
vn 0.554927 0.813087 0.175913
vn 0.329047 0.931632 0.154242
vn 0.295838 0.922770 0.246934
vn 0.475276 0.765356 0.433984
vn 0.512515 0.803776 0.302113
vn 0.295838 0.922770 0.246934
vn 0.249112 0.901162 0.354754
vn 0.352015 0.693847 0.628220
vn 0.475276 0.765356 0.433984
vn 0.249112 0.901162 0.354754
vn 0.193206 0.837852 0.510564
vn 0.251306 0.642174 0.724195
vn 0.352015 0.693847 0.628220
vn 0.193206 0.837852 0.510564
vn 0.131835 0.823235 0.552181
vn 0.158885 0.625222 0.764103
vn 0.251306 0.642174 0.724195
vn 0.131835 0.823235 0.552181
vn 0.026350 0.807716 0.588983
vn 0.249112 0.901162 0.354754
vn 0.101577 0.909840 0.402336
vn 0.131835 0.823235 0.552181
vn 0.193206 0.837852 0.510564
vn -0.554434 0.822763 0.125157
vn -0.640284 0.757620 0.126684
vn -0.638317 0.740799 0.209206
vn -0.540009 0.818302 0.196908
vn -0.540009 0.818302 0.196908
vn -0.638317 0.740799 0.209206
vn -0.606607 0.734037 0.305316
vn -0.512151 0.800331 0.311724
vn -0.512151 0.800331 0.311724
vn -0.606607 0.734037 0.305316
vn -0.561185 0.711369 0.423114
vn -0.471417 0.768014 0.433498
vn -0.471417 0.768014 0.433498
vn -0.561185 0.711369 0.423114
vn -0.516111 0.638603 0.570802
vn -0.425300 0.711235 0.559700
vn -0.640284 0.757620 0.126684
vn -0.789080 0.595487 0.150824
vn -0.794098 0.551742 0.254929
vn -0.638317 0.740799 0.209206
vn -0.606607 0.734037 0.305316
vn -0.772674 0.532716 0.345237
vn -0.693603 0.549307 0.466023
vn -0.561185 0.711369 0.423114
vn -0.638317 0.740799 0.209206
vn -0.794098 0.551742 0.254929
vn -0.772674 0.532716 0.345237
vn -0.606607 0.734037 0.305316
vn -0.561185 0.711369 0.423114
vn -0.693603 0.549307 0.466023
vn -0.615169 0.553088 0.561837
vn -0.516111 0.638603 0.570802
vn 0.431132 -0.408767 0.804385
vn 0.551728 -0.784464 0.283218
vn 0.333185 -0.832380 0.442868
vn 0.371482 -0.402017 0.836889
vn -0.602356 -0.750062 0.273084
vn -0.430430 -0.870475 0.238753
vn -0.421654 -0.839987 0.341511
vn -0.600060 -0.714308 0.360129
vn -0.808322 -0.512331 0.290056
vn -0.602356 -0.750062 0.273084
vn -0.600060 -0.714308 0.360129
vn -0.783771 -0.492739 0.378037
vn -0.931996 -0.277829 0.232797
vn -0.808322 -0.512331 0.290056
vn -0.783771 -0.492739 0.378037
vn -0.886044 -0.281923 0.368028
vn -0.964972 -0.146686 0.217512
vn -0.931996 -0.277829 0.232797
vn -0.886044 -0.281923 0.368028
vn -0.928281 -0.114703 0.353749
vn -0.948402 0.172458 0.266067
vn -0.964972 -0.146686 0.217512
vn -0.928281 -0.114703 0.353749
vn -0.910958 0.196272 0.362813
vn -0.794098 0.551742 0.254929
vn -0.948402 0.172458 0.266067
vn -0.910958 0.196272 0.362813
vn -0.772674 0.532716 0.345237
vn 0.234823 -0.953715 0.187844
vn 0.771016 -0.636792 0.005555
vn 0.751786 -0.659212 0.016084
vn 0.214234 -0.953624 0.211437
vn 0.306722 -0.945651 0.108009
vn 0.805240 -0.591961 0.034212
vn 0.771016 -0.636792 0.005555
vn 0.234823 -0.953715 0.187844
vn -0.789080 0.595487 0.150824
vn -0.979979 0.135892 0.145515
vn -0.948402 0.172458 0.266067
vn -0.794098 0.551742 0.254929
vn -0.979979 0.135892 0.145515
vn -0.980425 -0.167465 0.103551
vn -0.964972 -0.146686 0.217512
vn -0.948402 0.172458 0.266067
vn -0.980425 -0.167465 0.103551
vn -0.960810 -0.255003 0.108708
vn -0.931996 -0.277829 0.232797
vn -0.964972 -0.146686 0.217512
vn -0.960810 -0.255003 0.108708
vn -0.838251 -0.524019 0.150793
vn -0.808322 -0.512331 0.290056
vn -0.931996 -0.277829 0.232797
vn -0.838251 -0.524019 0.150793
vn -0.601253 -0.786107 0.143288
vn -0.602356 -0.750062 0.273084
vn -0.808322 -0.512331 0.290056
vn -0.601253 -0.786107 0.143288
vn -0.440971 -0.888995 0.123420
vn -0.430430 -0.870475 0.238753
vn -0.602356 -0.750062 0.273084
vn -0.430430 -0.870475 0.238753
vn 0.234823 -0.953715 0.187844
vn 0.214234 -0.953624 0.211437
vn -0.421654 -0.839987 0.341511
vn -0.191960 -0.968331 -0.159647
vn 0.312641 -0.890021 0.331841
vn 0.375851 -0.920961 0.102789
vn -0.236912 -0.971233 -0.024049
vn -0.128669 -0.965694 -0.225566
vn 0.049690 -0.985640 0.161386
vn 0.312641 -0.890021 0.331841
vn -0.191960 -0.968331 -0.159647
vn 0.312641 -0.890021 0.331841
vn 0.254488 -0.837594 0.483397
vn 0.412410 -0.871816 0.264299
vn 0.375851 -0.920961 0.102789
vn 0.049690 -0.985640 0.161386
vn 0.041707 -0.910803 0.410729
vn 0.254488 -0.837594 0.483397
vn 0.312641 -0.890021 0.331841
vn 0.809284 -0.586528 -0.032319
vn 0.821624 -0.566080 -0.066990
vn 0.288063 -0.932468 -0.217996
vn 0.732898 -0.674873 -0.086064
vn 0.751786 -0.659212 0.016084
vn 0.771016 -0.636792 0.005555
vn 0.815033 -0.578670 -0.029359
vn 0.802778 -0.596085 -0.015168
vn -0.008404 -0.983101 0.182872
vn -0.214129 -0.844684 0.490569
vn 0.254488 -0.837594 0.483397
vn 0.041707 -0.910803 0.410729
vn 0.802778 -0.596085 -0.015168
vn 0.815033 -0.578670 -0.029359
vn 0.821624 -0.566080 -0.066990
vn 0.809284 -0.586528 -0.032319
vn -0.221234 -0.974410 -0.039766
vn -0.687040 -0.725536 0.039675
vn -0.214129 -0.844684 0.490569
vn -0.008404 -0.983101 0.182872
vn 0.815033 -0.578670 -0.029359
vn 0.802007 -0.597313 -0.001465
vn 0.835426 -0.547415 -0.048983
vn 0.821624 -0.566080 -0.066990
vn 0.821624 -0.566080 -0.066990
vn 0.835426 -0.547415 -0.048983
vn 0.126919 -0.986541 -0.103095
vn 0.288063 -0.932468 -0.217996
vn 0.771016 -0.636792 0.005555
vn 0.805240 -0.591961 0.034212
vn 0.802007 -0.597313 -0.001465
vn 0.815033 -0.578670 -0.029359
vn -0.214129 -0.844684 0.490569
vn -0.111040 -0.964522 0.239514
vn 0.412410 -0.871816 0.264299
vn 0.254488 -0.837594 0.483397
vn -0.245456 -0.896717 -0.368307
vn 0.126919 -0.986541 -0.103095
vn 0.110662 -0.993858 0.000000
vn -0.074685 -0.997207 0.000000
vn 0.744860 0.048210 0.665477
vn 0.813776 0.262258 0.518642
vn 0.457458 0.326660 0.827058
vn 0.553540 0.097451 0.827101
vn 0.406229 0.746918 0.526395
vn 0.382236 0.548589 0.743603
vn 0.457458 0.326660 0.827058
vn 0.813776 0.262258 0.518642
vn 0.484577 0.753185 0.444858
vn 0.406229 0.746918 0.526395
vn 0.813776 0.262258 0.518642
vn 0.702453 0.566331 0.431078
vn 0.853086 0.478933 0.207044
vn 0.861067 0.508492 0.000000
vn 0.835654 0.549257 -0.000000
vn 0.841040 0.532356 0.096166
vn 0.344578 0.937836 0.041597
vn 0.350487 0.936568 -0.000000
vn 0.202936 0.979192 -0.000000
vn 0.213645 0.975495 0.052584
vn 0.841040 0.532356 0.096166
vn 0.835654 0.549257 -0.000000
vn 0.578203 0.815893 -0.000000
vn 0.583011 0.811771 0.033571
vn 0.805240 -0.591961 0.034212
vn 0.818597 -0.574368 0.000000
vn 0.799357 -0.600857 0.000000
vn 0.802007 -0.597313 -0.001465
vn 0.583011 0.811771 0.033571
vn 0.578203 0.815893 -0.000000
vn 0.350487 0.936568 -0.000000
vn 0.344578 0.937836 0.041597
vn 0.993642 0.010807 0.112066
vn 0.985967 -0.166938 0.000000
vn 0.039541 0.999218 -0.000000
vn 0.482791 0.875389 0.024659
vn -0.110440 0.992693 0.048616
vn -0.111096 0.993810 -0.000000
vn -0.322412 0.946599 -0.001007
vn -0.324433 0.940684 0.099277
vn 0.835426 -0.547415 -0.048983
vn 0.844909 -0.534910 0.000000
vn 0.110662 -0.993858 0.000000
vn 0.126919 -0.986541 -0.103095
vn -0.324433 0.940684 0.099277
vn -0.322412 0.946599 -0.001007
vn -0.443339 0.896353 -0.001068
vn -0.434895 0.890232 0.135474
vn 0.375851 -0.920961 0.102789
vn 0.406636 -0.913590 -0.000091
vn -0.283931 -0.958845 0.000000
vn -0.236912 -0.971233 -0.024049
vn -0.789080 0.595487 0.150824
vn -0.796255 0.604866 -0.010682
vn -0.986495 0.160041 -0.034853
vn -0.979979 0.135892 0.145515
vn 0.954535 -0.297930 0.010041
vn 0.874326 -0.485339 0.000000
vn 0.933826 0.357728 0.000000
vn 0.871784 0.431009 0.232861
vn -0.979979 0.135892 0.145515
vn -0.986495 0.160041 -0.034853
vn -0.985510 -0.167873 -0.024263
vn -0.980425 -0.167465 0.103551
vn -0.236912 -0.971233 -0.024049
vn -0.283931 -0.958845 0.000000
vn -0.390610 -0.920556 0.000000
vn -0.404522 -0.914342 0.018464
vn -0.980425 -0.167465 0.103551
vn -0.985510 -0.167873 -0.024263
vn -0.969686 -0.244355 -0.000000
vn -0.960810 -0.255003 0.108708
vn 0.871784 0.431009 0.232861
vn 0.933826 0.357728 0.000000
vn 0.742268 0.670103 -0.000000
vn 0.723145 0.626075 0.291706
vn 0.362305 -0.921868 0.137457
vn 0.379652 -0.925129 0.000000
vn 0.985967 -0.166938 0.000000
vn 0.993642 0.010807 0.112066
vn -0.111040 -0.964522 0.239514
vn -0.072505 -0.997368 0.000000
vn 0.475246 -0.879853 -0.000030
vn 0.412410 -0.871816 0.264299
vn -0.960810 -0.255003 0.108708
vn -0.969686 -0.244355 -0.000000
vn -0.850183 -0.526487 -0.000000
vn -0.838251 -0.524019 0.150793
vn -0.838251 -0.524019 0.150793
vn -0.850183 -0.526487 -0.000000
vn -0.599883 -0.800088 0.000000
vn -0.601253 -0.786107 0.143288
vn -0.601253 -0.786107 0.143288
vn -0.599883 -0.800088 0.000000
vn -0.444181 -0.895937 0.000000
vn -0.440971 -0.888995 0.123420
vn -0.640284 0.757620 0.126684
vn -0.639929 0.768435 -0.000000
vn -0.796255 0.604866 -0.010682
vn -0.789080 0.595487 0.150824
vn 0.802007 -0.597313 -0.001465
vn 0.799357 -0.600857 0.000000
vn 0.844909 -0.534910 0.000000
vn 0.835426 -0.547415 -0.048983
vn -0.440971 -0.888995 0.123420
vn 0.306722 -0.945651 0.108009
vn 0.234823 -0.953715 0.187844
vn -0.430430 -0.870475 0.238753
vn 0.412410 -0.871816 0.264299
vn 0.475246 -0.879853 -0.000030
vn 0.406636 -0.913590 -0.000091
vn 0.375851 -0.920961 0.102789
vn -0.554434 0.822763 0.125157
vn -0.558560 0.829464 -0.000061
vn -0.639929 0.768435 -0.000000
vn -0.640284 0.757620 0.126684
vn 0.723145 0.626075 0.291706
vn 0.742268 0.670103 -0.000000
vn 0.861067 0.508492 0.000000
vn 0.853086 0.478933 0.207044
vn -0.074685 -0.997207 0.000000
vn 0.110662 -0.993858 0.000000
vn 0.126890 -0.986532 0.103215
vn -0.245456 -0.896717 0.368308
vn 0.306722 -0.945651 0.108009
vn 0.328481 -0.944511 0.000000
vn 0.818597 -0.574368 0.000000
vn 0.805240 -0.591961 0.034212
vn 0.482791 0.875389 -0.024659
vn 0.625626 0.627937 0.462912
vn -0.128419 0.190300 0.973291
vn -0.620584 0.740541 0.257825
vn -0.440971 -0.888995 0.123420
vn -0.444181 -0.895937 0.000000
vn 0.328481 -0.944511 0.000000
vn 0.306722 -0.945651 0.108009
vn 0.954535 -0.297930 -0.010041
vn 0.874326 -0.485339 0.000000
vn 0.707211 -0.707003 0.000000
vn 0.678897 -0.662773 0.315962
vn 0.874326 -0.485339 0.000000
vn 0.954535 -0.297930 0.010041
vn 0.678897 -0.662773 -0.315962
vn 0.707211 -0.707003 0.000000
vn 0.039541 0.999218 -0.000000
vn 0.482791 0.875389 -0.024659
vn -0.620584 0.740541 0.257825
vn -0.637085 0.770794 -0.000000
vn 0.482791 0.875389 0.024659
vn 0.039541 0.999218 -0.000000
vn -0.637085 0.770794 -0.000000
vn -0.620584 0.740541 -0.257826
vn 0.954535 -0.297930 0.010041
vn 0.956395 0.118451 -0.266981
vn 0.303742 -0.236552 -0.922921
vn 0.678897 -0.662773 -0.315962
vn 0.625615 0.627967 -0.462885
vn 0.482791 0.875389 0.024659
vn -0.620584 0.740541 -0.257826
vn -0.128419 0.190300 -0.973291
vn 0.625626 0.627937 0.462912
vn 0.956371 0.118435 0.267073
vn 0.303742 -0.236552 0.922921
vn -0.128419 0.190300 0.973291
vn 0.956371 0.118435 0.267073
vn 0.954535 -0.297930 -0.010041
vn 0.678897 -0.662773 0.315962
vn 0.303742 -0.236552 0.922921
vn 0.956395 0.118451 -0.266981
vn 0.625615 0.627967 -0.462885
vn -0.128419 0.190300 -0.973291
vn 0.303742 -0.236552 -0.922921
vn -0.128419 0.190300 -0.973291
vn -0.620584 0.740541 -0.257826
vn -0.875387 -0.481487 0.043215
vn -0.734069 -0.537772 -0.414661
vn 0.678897 -0.662773 0.315962
vn 0.707211 -0.707003 0.000000
vn -0.074685 -0.997207 0.000000
vn -0.245456 -0.896717 0.368308
vn 0.303742 -0.236552 0.922921
vn 0.678897 -0.662773 0.315962
vn -0.245456 -0.896717 0.368308
vn -0.565190 -0.689582 0.452810
vn -0.620584 0.740541 -0.257826
vn -0.637085 0.770794 -0.000000
vn -0.995107 0.098802 -0.000000
vn -0.875387 -0.481487 0.043215
vn -0.128419 0.190300 0.973291
vn 0.303742 -0.236552 0.922921
vn -0.565190 -0.689582 0.452810
vn -0.734069 -0.537772 0.414661
vn -0.620584 0.740541 0.257825
vn -0.128419 0.190300 0.973291
vn -0.734069 -0.537772 0.414661
vn -0.875387 -0.481487 -0.043215
vn 0.707211 -0.707003 0.000000
vn 0.678897 -0.662773 -0.315962
vn -0.245456 -0.896717 -0.368307
vn -0.074685 -0.997207 0.000000
vn 0.678897 -0.662773 -0.315962
vn 0.303742 -0.236552 -0.922921
vn -0.565190 -0.689582 -0.452810
vn -0.245456 -0.896717 -0.368307
vn -0.637085 0.770794 -0.000000
vn -0.620584 0.740541 0.257825
vn -0.875387 -0.481487 -0.043215
vn -0.995107 0.098802 -0.000000
vn -0.350978 0.822718 0.447158
vn -0.408413 0.800006 0.439533
vn -0.341444 0.749262 0.567470
vn -0.256345 0.742644 0.618682
vn -0.394052 0.859754 0.324878
vn -0.452594 0.831216 0.322861
vn -0.408413 0.800006 0.439533
vn -0.350978 0.822718 0.447158
vn -0.416376 0.877284 0.238753
vn -0.485917 0.845205 0.222515
vn -0.452594 0.831216 0.322861
vn -0.394052 0.859754 0.324878
vn -0.434895 0.890232 0.135474
vn -0.504933 0.852682 0.134072
vn -0.485917 0.845205 0.222515
vn -0.416376 0.877284 0.238753
vn -0.425300 0.711235 0.559700
vn -0.323161 0.541273 0.776267
vn -0.209019 0.596664 0.774793
vn -0.341444 0.749262 0.567470
vn 0.622974 -0.711129 0.325882
vn 0.375522 -0.900194 -0.220530
vn -0.221234 -0.974410 -0.039766
vn 0.551728 -0.784464 0.283218
vn 0.303742 -0.236552 -0.922921
vn -0.128419 0.190300 -0.973291
vn -0.734069 -0.537772 -0.414661
vn -0.565190 -0.689582 -0.452810
vn 0.145967 -0.264654 0.953232
vn 0.351848 -0.490369 0.797334
vn 0.431132 -0.408767 0.804385
vn 0.273836 -0.156901 0.948892
vn 0.025289 -0.095220 0.995135
vn 0.145967 -0.264654 0.953232
vn 0.273836 -0.156901 0.948892
vn 0.161312 0.006297 0.986883
vn -0.074627 0.079873 0.994008
vn 0.025289 -0.095220 0.995135
vn 0.161312 0.006297 0.986883
vn 0.077449 0.160654 0.983968
vn -0.207449 0.294565 0.932843
vn -0.074627 0.079873 0.994008
vn 0.077449 0.160654 0.983968
vn -0.030771 0.348657 0.936745
vn -0.323161 0.541273 0.776267
vn -0.207449 0.294565 0.932843
vn -0.030771 0.348657 0.936745
vn -0.209019 0.596664 0.774793
vn -0.435528 0.890094 -0.134346
vn -0.503742 0.853368 -0.134192
vn -0.511905 0.859042 -0.000824
vn -0.443339 0.896353 -0.001068
vn 0.372878 -0.900631 0.223217
vn -0.222027 -0.974199 0.040499
vn -0.687040 -0.725536 -0.039675
vn -0.295525 -0.942041 0.158821
vn -0.350999 0.822755 -0.447073
vn -0.256377 0.742646 -0.618667
vn -0.341444 0.749262 -0.567470
vn -0.408461 0.800027 -0.439449
vn -0.394263 0.859921 -0.324179
vn -0.350999 0.822755 -0.447073
vn -0.408461 0.800027 -0.439449
vn -0.452452 0.831564 -0.322162
vn -0.416788 0.877767 -0.236247
vn -0.394263 0.859921 -0.324179
vn -0.452452 0.831564 -0.322162
vn -0.485141 0.846036 -0.221047
vn -0.435528 0.890094 -0.134346
vn -0.416788 0.877767 -0.236247
vn -0.485141 0.846036 -0.221047
vn -0.503742 0.853368 -0.134192
vn -0.425423 0.711144 -0.559723
vn -0.341444 0.749262 -0.567470
vn -0.208992 0.596677 -0.774789
vn -0.323163 0.541333 -0.776225
vn 0.622581 -0.711358 -0.326131
vn 0.550096 -0.787494 -0.277935
vn -0.222027 -0.974199 0.040499
vn 0.372878 -0.900631 0.223217
vn 0.351848 -0.490369 0.797334
vn 0.622974 -0.711129 0.325882
vn 0.551728 -0.784464 0.283218
vn 0.431132 -0.408767 0.804385
vn 0.145934 -0.264600 -0.953252
vn 0.273801 -0.156959 -0.948893
vn 0.431551 -0.409088 -0.803997
vn 0.352143 -0.490840 -0.796914
vn 0.024713 -0.095219 -0.995149
vn 0.161109 0.006277 -0.986917
vn 0.273801 -0.156959 -0.948893
vn 0.145934 -0.264600 -0.953252
vn -0.074805 0.079582 -0.994018
vn 0.077345 0.160587 -0.983987
vn 0.161109 0.006277 -0.986917
vn 0.024713 -0.095219 -0.995149
vn -0.207298 0.294554 -0.932880
vn -0.030927 0.348852 -0.936667
vn 0.077345 0.160587 -0.983987
vn -0.074805 0.079582 -0.994018
vn -0.323163 0.541333 -0.776225
vn -0.208992 0.596677 -0.774789
vn -0.030927 0.348852 -0.936667
vn -0.207298 0.294554 -0.932880
vn -0.478592 0.456650 -0.749947
vn -0.323163 0.541333 -0.776225
vn -0.207298 0.294554 -0.932880
vn -0.391023 0.226581 -0.892055
vn -0.391023 0.226581 -0.892055
vn -0.207298 0.294554 -0.932880
vn -0.074805 0.079582 -0.994018
vn -0.254665 -0.012086 -0.966954
vn -0.254665 -0.012086 -0.966954
vn -0.074805 0.079582 -0.994018
vn 0.024713 -0.095219 -0.995149
vn -0.134657 -0.201492 -0.970190
vn -0.134657 -0.201492 -0.970190
vn 0.024713 -0.095219 -0.995149
vn 0.145934 -0.264600 -0.953252
vn -0.008650 -0.366333 -0.930444
vn -0.008650 -0.366333 -0.930444
vn 0.145934 -0.264600 -0.953252
vn 0.352143 -0.490840 -0.796914
vn 0.213798 -0.505002 -0.836220
vn 0.352143 -0.490840 -0.796914
vn 0.431551 -0.409088 -0.803997
vn 0.550096 -0.787494 -0.277935
vn 0.622581 -0.711358 -0.326131
vn 0.625951 -0.657175 -0.419888
vn 0.622581 -0.711358 -0.326131
vn 0.372878 -0.900631 0.223217
vn 0.732799 -0.675004 0.085881
vn -0.516264 0.638676 -0.570582
vn -0.425423 0.711144 -0.559723
vn -0.323163 0.541333 -0.776225
vn -0.478592 0.456650 -0.749947
vn 0.732799 -0.675004 0.085881
vn 0.372878 -0.900631 0.223217
vn -0.295525 -0.942041 0.158821
vn 0.288046 -0.932438 0.218148
vn -0.478581 0.456742 0.749898
vn -0.391035 0.226604 0.892044
vn -0.207449 0.294565 0.932843
vn -0.323161 0.541273 0.776267
vn -0.391035 0.226604 0.892044
vn -0.254228 -0.012674 0.967061
vn -0.074627 0.079873 0.994008
vn -0.207449 0.294565 0.932843
vn -0.254228 -0.012674 0.967061
vn -0.134474 -0.201558 0.970201
vn 0.025289 -0.095220 0.995135
vn -0.074627 0.079873 0.994008
vn -0.134474 -0.201558 0.970201
vn -0.008708 -0.366291 0.930460
vn 0.145967 -0.264654 0.953232
vn 0.025289 -0.095220 0.995135
vn -0.008708 -0.366291 0.930460
vn 0.213577 -0.504824 0.836383
vn 0.351848 -0.490369 0.797334
vn 0.145967 -0.264654 0.953232
vn 0.213798 -0.505002 -0.836220
vn 0.352143 -0.490840 -0.796914
vn 0.622581 -0.711358 -0.326131
vn 0.625951 -0.657175 -0.419888
vn 0.625744 -0.656851 0.420703
vn 0.732898 -0.674873 -0.086064
vn 0.375522 -0.900194 -0.220530
vn 0.622974 -0.711129 0.325882
vn -0.516111 0.638603 0.570802
vn -0.478581 0.456742 0.749898
vn -0.323161 0.541273 0.776267
vn -0.425300 0.711235 0.559700
vn -0.504933 0.852682 0.134072
vn -0.511905 0.859042 -0.000824
vn -0.558560 0.829464 -0.000061
vn -0.554434 0.822763 0.125157
vn -0.408413 0.800006 0.439533
vn -0.471417 0.768014 0.433498
vn -0.425300 0.711235 0.559700
vn -0.341444 0.749262 0.567470
vn -0.452594 0.831216 0.322861
vn -0.512151 0.800331 0.311724
vn -0.471417 0.768014 0.433498
vn -0.408413 0.800006 0.439533
vn -0.485917 0.845205 0.222515
vn -0.540009 0.818302 0.196908
vn -0.512151 0.800331 0.311724
vn -0.452594 0.831216 0.322861
vn -0.504933 0.852682 0.134072
vn -0.554434 0.822763 0.125157
vn -0.540009 0.818302 0.196908
vn -0.485917 0.845205 0.222515
vn -0.503742 0.853368 -0.134192
vn -0.554303 0.822842 -0.125218
vn -0.558560 0.829464 -0.000061
vn -0.511905 0.859042 -0.000824
vn 0.732898 -0.674873 -0.086064
vn 0.288063 -0.932468 -0.217996
vn -0.295443 -0.942066 -0.158821
vn 0.375522 -0.900194 -0.220530
vn -0.408461 0.800027 -0.439449
vn -0.341444 0.749262 -0.567470
vn -0.425423 0.711144 -0.559723
vn -0.471791 0.767922 -0.433254
vn -0.452452 0.831564 -0.322162
vn -0.408461 0.800027 -0.439449
vn -0.471791 0.767922 -0.433254
vn -0.512453 0.800066 -0.311907
vn -0.485141 0.846036 -0.221047
vn -0.452452 0.831564 -0.322162
vn -0.512453 0.800066 -0.311907
vn -0.539951 0.818324 -0.196973
vn -0.503742 0.853368 -0.134192
vn -0.485141 0.846036 -0.221047
vn -0.539951 0.818324 -0.196973
vn -0.554303 0.822842 -0.125218
vn -0.295525 -0.942041 0.158821
vn -0.245456 -0.896717 0.368308
vn 0.126890 -0.986532 0.103215
vn 0.288046 -0.932438 0.218148
vn 0.126919 -0.986541 -0.103095
vn -0.245456 -0.896717 -0.368307
vn -0.295443 -0.942066 -0.158821
vn 0.288063 -0.932468 -0.217996
vn -0.214129 -0.844684 0.490569
vn -0.687040 -0.725536 0.039675
vn -0.565190 -0.689582 -0.452810
vn -0.734069 -0.537772 -0.414661
vn -0.214140 -0.844541 -0.490809
vn -0.734069 -0.537772 0.414661
vn -0.565190 -0.689582 0.452810
vn -0.687040 -0.725536 -0.039675
vn -0.214140 -0.844541 -0.490809
vn -0.111006 -0.964473 -0.239730
vn -0.875387 -0.481487 -0.043215
vn -0.734069 -0.537772 0.414661
vn -0.214129 -0.844684 0.490569
vn -0.734069 -0.537772 -0.414661
vn -0.875387 -0.481487 0.043215
vn -0.111040 -0.964522 0.239514
vn -0.072505 -0.997368 0.000000
vn -0.111040 -0.964522 0.239514
vn -0.875387 -0.481487 0.043215
vn -0.995107 0.098802 -0.000000
vn -0.072505 -0.997368 0.000000
vn -0.995107 0.098802 -0.000000
vn -0.875387 -0.481487 -0.043215
vn -0.111006 -0.964473 -0.239730
vn -0.245456 -0.896717 0.368308
vn -0.295525 -0.942041 0.158821
vn -0.687040 -0.725536 -0.039675
vn -0.565190 -0.689582 0.452810
vn 0.213577 -0.504824 0.836383
vn 0.625744 -0.656851 0.420703
vn 0.622974 -0.711129 0.325882
vn 0.351848 -0.490369 0.797334
vn -0.404522 -0.914342 0.018464
vn -0.390610 -0.920556 0.000000
vn 0.379652 -0.925129 0.000000
vn 0.362305 -0.921868 0.137457
vn 0.213645 0.975495 0.052584
vn 0.202936 0.979192 -0.000000
vn -0.111096 0.993810 -0.000000
vn -0.110440 0.992693 0.048616
vn 0.026434 0.580038 0.814160
vn 0.158885 0.625222 0.764103
vn 0.026350 0.807716 0.588983
vn -0.125733 0.762780 0.634317
vn 0.173112 0.965513 0.194467
vn -0.132596 0.973290 0.187419
vn -0.109808 0.940534 0.321461
vn 0.141253 0.939127 0.313191
vn 0.101577 0.909840 0.402336
vn -0.070041 0.902746 0.424433
vn 0.026350 0.807716 0.588983
vn 0.131835 0.823235 0.552181
vn 0.213645 0.975495 0.052584
vn -0.110440 0.992693 0.048616
vn -0.132596 0.973290 0.187419
vn 0.173112 0.965513 0.194467
vn 0.890490 -0.199010 0.409172
vn 0.373747 -0.925881 0.055301
vn 0.436518 -0.868331 -0.235485
vn 0.987791 0.066625 0.140817
vn 0.152161 -0.401541 0.903112
vn -0.116996 -0.930308 0.347618
vn 0.373747 -0.925881 0.055301
vn 0.890490 -0.199010 0.409172
vn 0.076271 -0.713304 0.696693
vn -0.285536 -0.954365 0.087498
vn -0.116996 -0.930308 0.347618
vn 0.152161 -0.401541 0.903112
vn 0.465971 -0.667101 0.581246
vn -0.254037 -0.924236 0.285050
vn -0.285536 -0.954365 0.087498
vn 0.076271 -0.713304 0.696693
vn 0.987791 0.066625 0.140817
vn 0.436518 -0.868331 -0.235485
vn 0.362305 -0.921868 0.137457
vn 0.993642 0.010807 0.112066
vn 0.141253 0.939127 0.313191
vn -0.109808 0.940534 0.321461
vn -0.070041 0.902746 0.424433
vn 0.101577 0.909840 0.402336
vn -0.220417 -0.858854 0.462371
vn -0.321554 -0.619849 0.715815
vn -0.340990 -0.229110 0.911720
vn -0.225369 -0.610332 0.759411
vn -0.225369 -0.610332 0.759411
vn -0.340990 -0.229110 0.911720
vn -0.247065 -0.229013 0.941548
vn -0.051775 -0.288512 0.956075
vn -0.051775 -0.288512 0.956075
vn -0.247065 -0.229013 0.941548
vn 0.024368 0.121499 0.992292
vn 0.099142 0.055763 0.993510
vn 0.099142 0.055763 0.993510
vn 0.024368 0.121499 0.992292
vn 0.228333 0.377065 0.897600
vn 0.159549 0.271285 0.949183
vn 0.159549 0.271285 0.949183
vn 0.228333 0.377065 0.897600
vn 0.259578 0.451773 0.853534
vn 0.134975 0.403070 0.905161
vn 0.134975 0.403070 0.905161
vn 0.259578 0.451773 0.853534
vn 0.158885 0.625222 0.764103
vn 0.026434 0.580038 0.814160
vn 0.041707 -0.910803 0.410729
vn -0.254037 -0.924236 0.285050
vn -0.321554 -0.619849 0.715815
vn -0.220417 -0.858854 0.462371
vn -0.404522 -0.914342 -0.018464
vn 0.362305 -0.921868 -0.137457
vn 0.379652 -0.925129 0.000000
vn -0.390610 -0.920556 0.000000
vn 0.213645 0.975495 -0.052585
vn -0.110494 0.992685 -0.048648
vn -0.111096 0.993810 -0.000000
vn 0.202936 0.979192 -0.000000
vn 0.026334 0.580084 -0.814131
vn -0.125749 0.762804 -0.634285
vn 0.026309 0.807735 -0.588959
vn 0.158730 0.625316 -0.764058
vn 0.173112 0.965513 -0.194467
vn 0.141253 0.939127 -0.313191
vn -0.109918 0.940533 -0.321429
vn -0.132703 0.973275 -0.187416
vn 0.101579 0.909851 -0.402310
vn 0.131795 0.823256 -0.552159
vn 0.026309 0.807735 -0.588959
vn -0.070082 0.902745 -0.424428
vn 0.213645 0.975495 -0.052585
vn 0.173112 0.965513 -0.194467
vn -0.132703 0.973275 -0.187416
vn -0.110494 0.992685 -0.048648
vn 0.890500 -0.199035 -0.409139
vn 0.987791 0.066625 -0.140817
vn 0.436518 -0.868331 0.235485
vn 0.373747 -0.925881 -0.055301
vn 0.152220 -0.401578 -0.903086
vn 0.890500 -0.199035 -0.409139
vn 0.373747 -0.925881 -0.055301
vn -0.116996 -0.930308 -0.347618
vn 0.076289 -0.713494 -0.696496
vn 0.152220 -0.401578 -0.903086
vn -0.116996 -0.930308 -0.347618
vn -0.285558 -0.954361 -0.087469
vn 0.465841 -0.667296 -0.581126
vn 0.076289 -0.713494 -0.696496
vn -0.285558 -0.954361 -0.087469
vn -0.254097 -0.924209 -0.285083
vn 0.987791 0.066625 -0.140817
vn 0.993642 0.010807 -0.112066
vn 0.362305 -0.921868 -0.137457
vn 0.436518 -0.868331 0.235485
vn 0.141253 0.939127 -0.313191
vn 0.101579 0.909851 -0.402310
vn -0.070082 0.902745 -0.424428
vn -0.109918 0.940533 -0.321429
vn -0.220476 -0.858821 -0.462403
vn -0.225329 -0.610161 -0.759560
vn -0.340896 -0.228980 -0.911789
vn -0.321707 -0.619862 -0.715735
vn -0.225329 -0.610161 -0.759560
vn -0.066228 -0.305450 -0.949902
vn -0.215143 -0.205056 -0.954812
vn -0.340896 -0.228980 -0.911789
vn -0.066228 -0.305450 -0.949902
vn 0.061616 0.031104 -0.997615
vn 0.048591 0.128532 -0.990514
vn -0.215143 -0.205056 -0.954812
vn 0.061616 0.031104 -0.997615
vn 0.139970 0.264999 -0.954036
vn 0.236124 0.382449 -0.893296
vn 0.048591 0.128532 -0.990514
vn 0.139970 0.264999 -0.954036
vn 0.134117 0.403185 -0.905237
vn 0.258891 0.452348 -0.853438
vn 0.236124 0.382449 -0.893296
vn 0.134117 0.403185 -0.905237
vn 0.026334 0.580084 -0.814131
vn 0.158730 0.625316 -0.764058
vn 0.258891 0.452348 -0.853438
vn 0.041781 -0.910857 -0.410603
vn -0.220476 -0.858821 -0.462403
vn -0.321707 -0.619862 -0.715735
vn -0.254097 -0.924209 -0.285083
s off
g Skull_LowPoly
usemtl Skull_LowPolySG
f 6/18/1 7/640/2 133/17/3 132/16/4
f 433/239/5 431/203/6 465/513/7 489/34/8
f 8/540/9 9/10/10 135/77/11 134/442/12
f 28/364/13 2/306/14 128/37/15 19/413/16
f 2/306/17 3/176/18 129/562/19 128/37/20
f 3/176/21 4/58/22 130/519/23 129/562/24
f 4/58/25 5/305/26 131/452/27 130/519/28
f 5/305/29 6/18/30 132/16/31 131/452/32
f 495/380/33 496/122/34 17/625/35 18/455/36
f 47/607/37 36/575/38 10/639/39 1/317/40
f 498/466/41 497/467/42 11/468/43 12/120/44
f 499/264/45 498/466/46 12/120/47 13/133/48
f 500/53/49 499/264/50 13/133/51 14/121/52
f 501/324/53 500/53/54 14/121/55 15/20/56
f 502/465/57 501/324/58 15/20/59 16/443/60
f 7/640/61 8/59/62 134/323/63 133/17/64
f 14/121/65 13/133/66 22/219/67 23/175/68
f 15/20/69 14/121/70 23/175/71 24/450/72
f 16/443/73 15/20/74 24/450/75 25/481/76
f 496/122/77 502/465/78 16/443/79 17/625/80
f 18/455/81 17/625/82 26/604/83 27/469/84
f 59/399/85 47/607/86 1/317/87 158/15/88
f 12/120/89 11/468/90 20/363/91 21/544/92
f 13/133/93 12/120/94 21/544/95 22/219/96
f 27/469/97 26/604/98 34/624/99 35/439/100
f 36/575/101 28/364/102 19/413/103 10/639/104
f 21/544/105 20/363/106 29/449/107 30/161/108
f 22/219/109 21/544/110 30/161/111 31/514/112
f 25/481/113 24/450/114 32/515/115 33/56/116
f 17/625/117 16/443/118 25/481/119 26/604/120
f 22/219/121 31/514/122 69/57/123 56/605/124
f 33/56/125 32/515/126 41/431/127 42/216/128
f 24/450/129 23/175/130 57/414/131 58/522/132
f 26/604/133 25/481/134 33/56/135 34/624/136
f 35/439/137 34/624/138 43/130/139 44/201/140
f 82/580/141 59/399/142 158/15/143 159/99/144
f 30/161/145 29/449/146 37/287/147 38/230/148
f 31/514/149 30/161/150 38/230/151 39/372/152
f 512/561/153 509/193/154 36/575/155 47/607/156
f 38/230/157 37/287/158 48/283/159 49/274/160
f 39/372/161 38/230/162 49/274/163 50/526/164
f 40/344/165 39/372/166 50/526/167 51/371/168
f 40/344/169 41/431/170 70/560/171 45/383/172
f 41/431/173 40/344/174 51/371/175 52/257/176
f 41/431/177 32/515/178 68/492/179 70/560/180
f 42/216/181 41/431/182 52/257/183 53/68/184
f 31/514/185 39/372/186 46/21/187 69/57/188
f 34/624/189 33/56/190 42/216/191 43/130/192
f 44/201/193 43/130/194 54/22/195 55/258/196
f 32/515/197 24/450/198 58/522/199 68/492/200
f 173/440/201 89/622/202 90/608/203 174/563/204
f 164/23/205 154/537/206 83/441/207 175/35/208
f 506/318/209 507/521/210 76/206/211 77/113/212
f 175/35/213 83/441/214 84/564/215 169/538/216
f 169/538/217 84/564/218 85/340/219 168/615/220
f 168/615/221 85/340/222 86/404/223 170/293/224
f 170/293/225 86/404/226 87/123/227 171/502/228
f 23/175/229 22/219/230 56/605/231 57/414/232
f 171/502/233 87/123/234 88/111/235 172/231/236
f 39/372/237 40/344/238 45/383/239 46/21/240
f 43/130/241 42/216/242 53/68/243 54/22/244
f 78/83/245 77/113/246 71/479/247 72/451/248
f 75/395/249 74/474/250 78/83/251 72/451/252
f 121/288/253 109/457/254 91/482/255 79/610/256
f 495/516/257 503/242/258 75/395/259 9/10/260
f 106/396/261 96/565/262 95/279/263 94/240/264
f 503/242/265 504/142/266 74/474/267 75/395/268
f 96/565/269 108/80/270 92/619/271 95/279/272
f 504/142/273 505/392/274 78/83/275 74/474/276
f 505/392/277 506/318/278 77/113/279 78/83/280
f 77/113/281 76/206/282 73/517/283 71/479/284
f 89/622/285 104/461/286 105/618/287 90/608/288
f 154/537/289 155/115/290 98/558/291 83/441/292
f 83/441/293 98/558/294 99/116/295 84/564/296
f 84/564/297 99/116/298 100/114/299 85/340/300
f 85/340/301 100/114/302 101/280/303 86/404/304
f 86/404/305 101/280/306 102/397/307 87/123/308
f 110/409/309 111/207/310 80/357/311 81/136/312
f 87/123/313 102/397/314 103/307/315 88/111/316
f 111/207/317 121/288/318 79/610/319 80/357/320
f 172/231/321 88/111/322 89/24/323 173/184/324
f 108/80/325 110/409/326 81/136/327 92/619/328
f 107/117/329 106/396/330 94/240/331 93/106/332
f 109/457/333 107/117/334 93/106/335 91/482/336
f 139/284/337 147/211/338 96/565/339 106/396/340
f 98/558/341 113/281/342 114/217/343 99/116/344
f 99/116/345 114/217/346 115/79/347 100/114/348
f 100/114/349 115/79/350 116/462/351 101/280/352
f 101/280/353 116/462/354 117/54/355 102/397/356
f 122/19/357 125/321/358 109/457/359 121/288/360
f 102/397/361 117/54/362 118/576/363 103/307/364
f 124/633/365 123/39/366 111/207/367 110/409/368
f 88/111/369 103/307/370 104/361/371 89/24/372
f 147/211/373 126/435/374 108/80/375 96/565/376
f 104/461/377 119/285/378 120/55/379 105/618/380
f 155/115/381 156/566/382 113/281/383 98/558/384
f 126/435/385 124/633/386 110/409/387 108/80/388
f 123/39/389 122/19/390 121/288/391 111/207/392
f 125/321/393 138/86/394 107/117/395 109/457/396
f 442/309/397 128/37/398 129/562/399 443/129/400
f 443/129/401 129/562/402 130/519/403 444/322/404
f 444/322/405 130/519/406 131/452/407 438/475/408
f 438/475/409 131/452/410 132/16/411 437/208/412
f 138/86/413 139/284/414 106/396/415 107/117/416
f 437/208/417 132/16/418 133/17/419 439/25/420
f 56/210/421 69/209/422 126/435/423 147/211/424
f 103/307/425 118/576/426 119/483/427 104/361/428
f 58/137/429 57/319/430 139/284/431 138/86/432
f 440/138/433 134/442/434 135/77/435 441/163/436
f 445/85/437 19/413/438 128/37/439 442/309/440
f 45/456/441 70/254/442 122/19/443 123/39/444
f 70/254/445 68/637/446 125/321/447 122/19/448
f 69/209/449 46/40/450 124/633/451 126/435/452
f 68/637/453 58/137/454 138/86/455 125/321/456
f 51/371/457 50/526/458 146/241/459 137/345/460
f 50/526/461 49/274/462 145/614/463 146/241/464
f 49/274/465 48/283/466 144/341/467 145/614/468
f 508/82/469 511/282/470 59/399/471 82/580/472
f 55/258/473 54/22/474 141/539/475 143/343/476
f 57/319/477 56/210/478 147/211/479 139/284/480
f 53/68/481 52/257/482 136/273/483 140/559/484
f 46/40/485 45/456/486 123/39/487 124/633/488
f 52/257/489 51/371/490 137/345/491 136/273/492
f 509/193/493 510/480/494 28/364/495 36/575/496
f 48/283/497 152/218/498 157/551/499 144/341/500
f 511/282/501 512/561/502 47/607/503 59/399/504
f 157/551/505 152/218/506 112/593/507 97/259/508
f 151/552/509 150/381/510 142/358/511 127/41/512
f 152/218/513 151/552/514 127/41/515 112/593/516
f 37/287/517 151/552/518 152/218/519 48/283/520
f 29/449/521 150/381/522 151/552/523 37/287/524
f 20/363/525 149/609/526 150/381/527 29/449/528
f 11/468/529 148/398/530 149/609/531 20/363/532
f 497/467/533 510/303/534 148/398/535 11/468/536
f 150/381/537 149/609/538 148/398/539 142/358/540
f 491/158/541 474/84/542 162/255/543 163/308/544
f 474/84/545 475/265/546 160/162/547 162/255/548
f 475/265/549 476/436/550 161/621/551 160/162/552
f 476/436/553 473/601/554 156/566/555 161/621/556
f 163/308/557 162/255/558 166/26/559 153/52/560
f 160/162/561 161/621/562 154/537/563 164/23/564
f 162/255/565 160/162/566 164/23/567 166/26/568
f 161/621/569 156/566/570 155/115/571 154/537/572
f 439/25/573 133/17/574 134/323/575 440/27/576
f 179/342/577 171/502/578 172/231/579 180/585/580
f 178/185/581 170/293/582 171/502/583 179/342/584
f 177/577/585 168/615/586 170/293/587 178/185/588
f 185/145/589 169/538/590 168/615/591 177/577/592
f 183/100/593 175/35/594 169/538/595 185/145/596
f 166/26/597 164/23/598 175/35/599 183/100/600
f 181/260/601 173/440/602 174/563/603 182/434/604
f 66/520/605 181/260/606 182/434/607 67/362/608
f 153/52/609 166/26/610 183/100/611 60/131/612
f 60/131/613 183/100/614 185/145/615 61/602/616
f 61/602/617 185/145/618 177/577/619 62/314/620
f 62/314/621 177/577/622 178/185/623 63/261/624
f 63/261/625 178/185/626 179/342/627 64/586/628
f 64/586/629 179/342/630 180/585/631 65/587/632
f 180/585/633 172/231/634 173/184/635 181/422/636
f 71/479/637 73/517/638 176/244/639 167/36/640
f 72/451/641 71/479/642 167/36/643 75/395/644
f 167/36/645 176/244/646 184/78/647 165/153/648
f 75/395/649 167/36/650 165/153/651 9/10/652
f 105/618/653 120/55/654 188/256/655 187/476/656
f 174/563/657 90/608/658 186/156/659 182/434/660
f 135/77/661 9/10/662 165/153/663 189/139/664
f 90/608/665 105/618/666 187/476/667 186/156/668
f 441/163/669 135/77/670 189/139/671 450/463/672
f 186/156/673 187/476/674 191/134/675 190/478/676
f 187/476/677 188/256/678 192/30/679 191/134/680
f 182/434/681 186/156/682 190/478/683 67/362/684
f 189/139/685 165/153/686 184/78/687 193/81/688
f 481/438/689 489/34/690 465/513/691 456/518/692
f 92/619/693 81/136/694 80/357/695 95/279/696
f 91/482/697 95/279/698 80/357/699 79/610/700
f 93/106/701 94/240/702 95/279/703 91/482/704
f 146/241/705 145/614/706 405/220/707 406/60/708
f 157/551/709 97/259/710 398/509/711 408/147/712
f 145/614/713 144/341/714 404/294/715 405/220/716
f 67/362/717 190/478/718 413/359/719 394/472/720
f 144/341/721 157/551/722 408/147/723 404/294/724
f 143/343/725 141/539/726 402/453/727 403/603/728
f 508/82/729 82/580/730 397/101/731 514/28/732
f 191/134/733 192/30/734 415/606/735 414/125/736
f 82/580/737 159/99/738 409/103/739 397/101/740
f 176/244/741 73/517/742 395/118/743 411/160/744
f 153/52/745 60/131/746 387/470/747 407/460/748
f 140/559/749 136/273/750 399/346/751 401/148/752
f 60/131/753 61/602/754 388/29/755 387/470/756
f 73/517/757 76/206/758 396/320/759 395/118/760
f 61/602/761 62/314/762 389/295/763 388/29/764
f 136/273/765 137/345/766 400/382/767 399/346/768
f 507/553/769 143/343/770 403/603/771 513/347/772
f 193/81/773 184/78/774 412/204/775 416/243/776
f 62/314/777 63/261/778 390/506/779 389/295/780
f 63/261/781 64/586/782 391/588/783 390/506/784
f 64/586/785 65/587/786 392/269/787 391/588/788
f 163/308/789 153/52/790 407/460/791 410/623/792
f 190/478/793 191/134/794 414/125/795 413/359/796
f 65/587/797 180/585/798 181/422/799 66/569/800
f 184/78/801 176/244/802 411/160/803 412/204/804
f 491/158/805 163/308/806 410/623/807 492/38/808
f 137/345/809 146/241/810 406/60/811 400/382/812
f 352/574/813 409/103/814 451/177/815 462/205/816
f 66/520/817 67/362/818 394/472/819 393/159/820
f 199/348/821 325/315/822 326/499/823 200/423/824
f 65/587/825 66/569/826 393/226/827 392/269/828
f 201/286/829 327/437/830 328/73/831 202/360/832
f 221/263/833 212/74/834 321/573/835 195/119/836
f 195/119/837 321/573/838 322/393/839 196/76/840
f 196/76/841 322/393/842 323/102/843 197/349/844
f 197/349/845 323/102/846 324/454/847 198/594/848
f 198/594/849 324/454/850 325/315/851 199/348/852
f 515/252/853 211/63/854 210/445/855 516/135/856
f 240/304/857 194/132/858 203/464/859 229/61/860
f 518/421/861 205/503/862 204/584/863 517/501/864
f 519/310/865 206/504/866 205/503/867 518/421/868
f 520/227/869 207/253/870 206/504/871 519/310/872
f 521/65/873 208/613/874 207/253/875 520/227/876
f 522/312/877 209/548/878 208/613/879 521/65/880
f 200/423/881 326/499/882 327/75/883 201/632/884
f 207/253/885 216/350/886 215/505/887 206/504/888
f 208/613/889 217/268/890 216/350/891 207/253/892
f 209/548/893 218/140/894 217/268/895 208/613/896
f 516/135/897 210/445/898 209/548/899 522/312/900
f 211/63/901 220/186/902 219/141/903 210/445/904
f 252/394/905 351/11/906 194/132/907 240/304/908
f 205/503/909 214/143/910 213/477/911 204/584/912
f 206/504/913 215/505/914 214/143/915 205/503/916
f 220/186/917 228/500/918 227/9/919 219/141/920
f 229/61/921 203/464/922 212/74/923 221/263/924
f 214/143/925 223/95/926 222/187/927 213/477/928
f 215/505/929 224/507/930 223/95/931 214/143/932
f 218/140/933 226/188/934 225/292/935 217/268/936
f 210/445/937 219/141/938 218/140/939 209/548/940
f 215/505/941 249/221/942 262/389/943 224/507/944
f 226/188/945 235/189/946 234/333/947 225/292/948
f 217/268/949 251/424/950 250/425/951 216/350/952
f 219/141/953 227/9/954 226/188/955 218/140/956
f 228/500/957 237/508/958 236/325/959 227/9/960
f 275/541/961 352/574/962 351/11/963 252/394/964
f 223/95/965 231/87/966 230/542/967 222/187/968
f 224/507/969 232/550/970 231/87/971 223/95/972
f 532/458/973 240/304/974 229/61/975 529/328/976
f 231/87/977 242/616/978 241/69/979 230/542/980
f 232/550/981 243/149/982 242/616/983 231/87/984
f 233/150/985 244/1/986 243/149/987 232/550/988
f 233/150/989 238/199/990 263/376/991 234/333/992
f 234/333/993 245/334/994 244/1/995 233/150/996
f 234/333/997 263/376/998 261/190/999 225/292/1000
f 235/189/1001 246/493/1002 245/334/1003 234/333/1004
f 224/507/1005 262/389/1006 239/354/1007 232/550/1008
f 227/9/1009 236/325/1010 235/189/1011 226/188/1012
f 237/508/1013 248/12/1014 247/194/1015 236/325/1016
f 225/292/1017 261/190/1018 251/424/1019 217/268/1020
f 366/400/1021 367/387/1022 283/250/1023 282/611/1024
f 357/335/1025 368/567/1026 276/164/1027 347/245/1028
f 526/88/1029 270/331/1030 269/225/1031 527/534/1032
f 368/567/1033 362/296/1034 277/527/1035 276/164/1036
f 362/296/1037 361/165/1038 278/195/1039 277/527/1040
f 361/165/1041 363/543/1042 279/428/1043 278/195/1044
f 363/543/1045 364/172/1046 280/634/1047 279/428/1048
f 216/350/1049 250/425/1050 249/221/1051 215/505/1052
f 364/172/1053 365/365/1054 281/329/1055 280/634/1056
f 232/550/1057 239/354/1058 238/199/1059 233/150/1060
f 236/325/1061 247/194/1062 246/493/1063 235/189/1064
f 271/366/1065 265/251/1066 264/316/1067 270/331/1068
f 268/89/1069 265/251/1070 271/366/1071 267/533/1072
f 314/339/1073 272/212/1074 284/338/1075 302/31/1076
f 515/90/1077 202/360/1078 268/89/1079 523/166/1080
f 299/91/1081 287/71/1082 288/42/1083 289/43/1084
f 523/166/1085 268/89/1086 267/533/1087 524/170/1088
f 289/43/1089 288/42/1090 285/146/1091 301/379/1092
f 524/170/1093 267/533/1094 271/366/1095 525/377/1096
f 525/377/1097 271/366/1098 270/331/1099 526/88/1100
f 270/331/1101 264/316/1102 266/444/1103 269/225/1104
f 282/611/1105 283/250/1106 298/233/1107 297/197/1108
f 347/245/1109 276/164/1110 291/578/1111 348/178/1112
f 276/164/1113 277/527/1114 292/167/1115 291/578/1116
f 277/527/1117 278/195/1118 293/246/1119 292/167/1120
f 278/195/1121 279/428/1122 294/595/1123 293/246/1124
f 279/428/1125 280/634/1126 295/70/1127 294/595/1128
f 303/512/1129 274/94/1130 273/332/1131 304/572/1132
f 280/634/1133 281/329/1134 296/151/1135 295/70/1136
f 304/572/1137 273/332/1138 272/212/1139 314/339/1140
f 365/365/1141 366/191/1142 282/549/1143 281/329/1144
f 301/379/1145 285/146/1146 274/94/1147 303/512/1148
f 300/473/1149 286/535/1150 287/71/1151 299/91/1152
f 302/31/1153 284/338/1154 286/535/1155 300/473/1156
f 332/97/1157 299/91/1158 289/43/1159 340/448/1160
f 291/578/1161 292/167/1162 307/570/1163 306/66/1164
f 292/167/1165 293/246/1166 308/247/1167 307/570/1168
f 293/246/1169 294/595/1170 309/486/1171 308/247/1172
f 294/595/1173 295/70/1174 310/289/1175 309/486/1176
f 315/391/1177 314/339/1178 302/31/1179 318/270/1180
f 295/70/1181 296/151/1182 311/45/1183 310/289/1184
f 317/401/1185 303/512/1186 304/572/1187 316/248/1188
f 281/329/1189 282/549/1190 297/579/1191 296/151/1192
f 340/448/1193 289/43/1194 301/379/1195 319/420/1196
f 297/197/1197 298/233/1198 313/367/1199 312/67/1200
f 348/178/1201 291/578/1202 306/66/1203 349/179/1204
f 319/420/1205 301/379/1206 303/512/1207 317/401/1208
f 316/248/1209 304/572/1210 314/339/1211 315/391/1212
f 318/270/1213 302/31/1214 300/473/1215 331/511/1216
f 457/235/1217 458/626/1218 322/393/1219 321/573/1220
f 458/626/1221 459/222/1222 323/102/1223 322/393/1224
f 459/222/1225 453/484/1226 324/454/1227 323/102/1228
f 453/484/1229 452/528/1230 325/315/1231 324/454/1232
f 331/511/1233 300/473/1234 299/91/1235 332/97/1236
f 452/528/1237 454/545/1238 326/499/1239 325/315/1240
f 249/276/1241 340/448/1242 319/420/1243 262/635/1244
f 296/151/1245 297/579/1246 312/2/1247 311/45/1248
f 251/523/1249 331/511/1250 332/97/1251 250/485/1252
f 455/631/1253 456/518/1254 328/73/1255 327/437/1256
f 460/180/1257 457/235/1258 321/573/1259 212/74/1260
f 238/297/1261 316/248/1262 315/391/1263 263/291/1264
f 263/291/1265 315/391/1266 318/270/1267 261/313/1268
f 262/635/1269 319/420/1270 317/401/1271 239/326/1272
f 261/313/1273 318/270/1274 331/511/1275 251/523/1276
f 244/1/1277 330/554/1278 339/3/1279 243/149/1280
f 243/149/1281 339/3/1282 338/232/1283 242/616/1284
f 242/616/1285 338/232/1286 337/384/1287 241/69/1288
f 528/104/1289 275/541/1290 252/394/1291 531/546/1292
f 248/12/1293 336/275/1294 334/529/1295 247/194/1296
f 250/485/1297 332/97/1298 340/448/1299 249/276/1300
f 246/493/1301 333/92/1302 329/487/1303 245/334/1304
f 239/326/1305 317/401/1306 316/248/1307 238/297/1308
f 245/334/1309 329/487/1310 330/554/1311 244/1/1312
f 529/328/1313 229/61/1314 221/263/1315 530/200/1316
f 241/69/1317 337/384/1318 350/612/1319 345/494/1320
f 531/546/1321 252/394/1322 240/304/1323 532/458/1324
f 350/612/1325 290/405/1326 305/96/1327 345/494/1328
f 344/598/1329 320/596/1330 335/471/1331 343/300/1332
f 345/494/1333 305/96/1334 320/596/1335 344/598/1336
f 230/542/1337 241/69/1338 345/494/1339 344/598/1340
f 222/187/1341 230/542/1342 344/598/1343 343/300/1344
f 213/477/1345 222/187/1346 343/300/1347 342/192/1348
f 204/584/1349 213/477/1350 342/192/1351 341/7/1352
f 517/501/1353 204/584/1354 341/7/1355 530/327/1356
f 343/300/1357 335/471/1358 341/7/1359 342/192/1360
f 494/403/1361 356/278/1362 355/49/1363 486/368/1364
f 486/368/1365 355/49/1366 353/555/1367 487/8/1368
f 487/8/1369 353/555/1370 354/228/1371 488/266/1372
f 488/266/1373 354/228/1374 349/179/1375 485/406/1376
f 356/278/1377 346/530/1378 359/627/1379 355/49/1380
f 353/555/1381 357/335/1382 347/245/1383 354/228/1384
f 355/49/1385 359/627/1386 357/335/1387 353/555/1388
f 354/228/1389 347/245/1390 348/178/1391 349/179/1392
f 454/545/1393 455/355/1394 327/75/1395 326/499/1396
f 372/169/1397 373/109/1398 365/365/1399 364/172/1400
f 371/124/1401 372/169/1402 364/172/1403 363/543/1404
f 370/412/1405 371/124/1406 363/543/1407 361/165/1408
f 378/32/1409 370/412/1410 361/165/1411 362/296/1412
f 376/402/1413 378/32/1414 362/296/1415 368/567/1416
f 359/627/1417 376/402/1418 368/567/1419 357/335/1420
f 374/524/1421 375/198/1422 367/387/1423 366/400/1424
f 259/298/1425 260/599/1426 375/198/1427 374/524/1428
f 346/530/1429 253/214/1430 376/402/1431 359/627/1432
f 253/214/1433 254/370/1434 378/32/1435 376/402/1436
f 254/370/1437 255/330/1438 370/412/1439 378/32/1440
f 255/330/1441 256/510/1442 371/124/1443 370/412/1444
f 256/510/1445 257/110/1446 372/169/1447 371/124/1448
f 257/110/1449 258/168/1450 373/109/1451 372/169/1452
f 373/109/1453 374/589/1454 366/191/1455 365/365/1456
f 264/316/1457 360/290/1458 369/171/1459 266/444/1460
f 265/251/1461 268/89/1462 360/290/1463 264/316/1464
f 360/290/1465 358/497/1466 377/44/1467 369/171/1468
f 268/89/1469 202/360/1470 358/497/1471 360/290/1472
f 298/233/1473 380/432/1474 381/495/1475 313/367/1476
f 367/387/1477 375/198/1478 379/433/1479 283/250/1480
f 328/73/1481 382/62/1482 358/497/1483 202/360/1484
f 283/250/1485 379/433/1486 380/432/1487 298/233/1488
f 456/518/1489 465/513/1490 382/62/1491 328/73/1492
f 379/433/1493 383/262/1494 384/385/1495 380/432/1496
f 380/432/1497 384/385/1498 385/628/1499 381/495/1500
f 375/198/1501 260/599/1502 383/262/1503 379/433/1504
f 382/62/1505 386/271/1506 377/44/1507 358/497/1508
f 433/239/1509 385/628/1510 415/606/1511 435/498/1512
f 285/146/1513 288/42/1514 273/332/1515 274/94/1516
f 284/338/1517 272/212/1518 273/332/1519 288/42/1520
f 286/535/1521 284/338/1522 288/42/1523 287/71/1524
f 339/3/1525 406/60/1526 405/220/1527 338/232/1528
f 350/612/1529 408/147/1530 398/509/1531 290/405/1532
f 338/232/1533 405/220/1534 404/294/1535 337/384/1536
f 260/599/1537 394/472/1538 413/359/1539 383/262/1540
f 337/384/1541 404/294/1542 408/147/1543 350/612/1544
f 336/275/1545 403/603/1546 402/453/1547 334/529/1548
f 528/104/1549 514/28/1550 397/101/1551 275/541/1552
f 384/385/1553 414/125/1554 415/606/1555 385/628/1556
f 275/541/1557 397/101/1558 409/103/1559 352/574/1560
f 369/171/1561 411/160/1562 395/118/1563 266/444/1564
f 346/530/1565 407/460/1566 387/470/1567 253/214/1568
f 333/92/1569 401/148/1570 399/346/1571 329/487/1572
f 253/214/1573 387/470/1574 388/105/1575 254/370/1576
f 266/444/1577 395/118/1578 396/320/1579 269/225/1580
f 254/370/1581 388/105/1582 389/531/1583 255/330/1584
f 329/487/1585 399/346/1586 400/382/1587 330/554/1588
f 527/488/1589 513/347/1590 403/603/1591 336/275/1592
f 386/271/1593 416/243/1594 412/204/1595 377/44/1596
f 255/330/1597 389/531/1598 390/126/1599 256/510/1600
f 256/510/1601 390/126/1602 391/590/1603 257/110/1604
f 257/110/1605 391/590/1606 392/591/1607 258/168/1608
f 356/278/1609 410/623/1610 407/460/1611 346/530/1612
f 383/262/1613 413/359/1614 414/125/1615 384/385/1616
f 258/168/1617 259/4/1618 374/589/1619 373/109/1620
f 377/44/1621 412/204/1622 411/160/1623 369/171/1624
f 494/403/1625 492/38/1626 410/623/1627 356/278/1628
f 330/554/1629 400/382/1630 406/60/1631 339/3/1632
f 435/498/1633 415/606/1634 192/30/1635 429/301/1636
f 259/298/1637 393/159/1638 394/472/1639 260/599/1640
f 141/128/1641 54/430/1642 418/447/1643 420/416/1644
f 258/168/1645 392/591/1646 393/351/1647 259/4/1648
f 140/356/1649 401/378/1650 425/107/1651 419/98/1652
f 401/525/1653 333/13/1654 423/236/1655 425/411/1656
f 402/50/1657 141/128/1658 420/416/1659 426/33/1660
f 334/157/1661 402/50/1662 426/33/1663 424/459/1664
f 333/13/1665 246/249/1666 421/375/1667 423/236/1668
f 247/5/1669 334/157/1670 424/459/1671 422/237/1672
f 54/430/1673 53/547/1674 417/408/1675 418/447/1676
f 53/547/1677 140/356/1678 419/98/1679 417/408/1680
f 246/249/1681 247/5/1682 422/237/1683 421/375/1684
f 422/237/1685 424/459/1686 434/369/1687 432/302/1688
f 419/98/1689 425/107/1690 435/388/1691 429/277/1692
f 417/408/1693 419/98/1694 429/277/1695 427/352/1696
f 424/459/1697 426/33/1698 436/638/1699 434/369/1700
f 418/447/1701 417/408/1702 427/352/1703 428/311/1704
f 420/416/1705 418/447/1706 428/311/1707 430/536/1708
f 425/411/1709 423/236/1710 433/213/1711 435/144/1712
f 423/236/1713 421/375/1714 431/174/1715 433/213/1716
f 426/33/1717 420/416/1718 430/536/1719 436/638/1720
f 203/464/1721 464/490/1722 460/180/1723 212/74/1724
f 194/132/1725 463/272/1726 464/490/1727 203/464/1728
f 351/11/1729 461/386/1730 463/272/1731 194/132/1732
f 352/574/1733 462/205/1734 461/386/1735 351/11/1736
f 485/406/1737 482/629/1738 457/235/1739 460/180/1740
f 480/417/1741 481/438/1742 456/518/1743 455/631/1744
f 421/375/1745 422/237/1746 432/302/1747 431/174/1748
f 478/373/1749 479/152/1750 454/545/1751 452/528/1752
f 493/47/1753 478/373/1754 452/528/1755 453/484/1756
f 484/14/1757 493/47/1758 453/484/1759 459/222/1760
f 483/415/1761 484/14/1762 459/222/1763 458/626/1764
f 482/629/1765 483/415/1766 458/626/1767 457/235/1768
f 159/99/1769 447/182/1770 451/177/1771 409/103/1772
f 469/196/1773 441/163/1774 450/463/1775 477/419/1776
f 10/639/1777 19/413/1778 445/85/1779 449/407/1780
f 1/317/1781 10/639/1782 449/407/1783 448/581/1784
f 158/15/1785 1/317/1786 448/581/1787 446/267/1788
f 159/99/1789 158/15/1790 446/267/1791 447/182/1792
f 473/601/1793 445/85/1794 442/309/1795 470/568/1796
f 468/556/1797 440/138/1798 441/163/1799 469/196/1800
f 479/152/1801 480/6/1802 455/355/1803 454/545/1804
f 466/181/1805 437/208/1806 439/25/1807 467/496/1808
f 490/597/1809 438/475/1810 437/208/1811 466/181/1812
f 472/582/1813 444/322/1814 438/475/1815 490/597/1816
f 471/491/1817 443/129/1818 444/322/1819 472/582/1820
f 470/568/1821 442/309/1822 443/129/1823 471/491/1824
f 113/281/1825 470/568/1826 471/491/1827 114/217/1828
f 114/217/1829 471/491/1830 472/582/1831 115/79/1832
f 115/79/1833 472/582/1834 490/597/1835 116/462/1836
f 116/462/1837 490/597/1838 466/181/1839 117/54/1840
f 117/54/1841 466/181/1842 467/496/1843 118/576/1844
f 467/496/1845 439/25/1846 440/27/1847 468/418/1848
f 119/285/1849 468/556/1850 469/196/1851 120/55/1852
f 156/566/1853 473/601/1854 470/568/1855 113/281/1856
f 120/55/1857 469/196/1858 477/419/1859 188/256/1860
f 306/66/1861 307/570/1862 483/415/1863 482/629/1864
f 307/570/1865 308/247/1866 484/14/1867 483/415/1868
f 308/247/1869 309/486/1870 493/47/1871 484/14/1872
f 309/486/1873 310/289/1874 478/373/1875 493/47/1876
f 310/289/1877 311/45/1878 479/152/1879 478/373/1880
f 118/576/1881 467/496/1882 468/418/1883 119/483/1884
f 312/67/1885 313/367/1886 481/438/1887 480/417/1888
f 349/179/1889 306/66/1890 482/629/1891 485/406/1892
f 462/205/1893 451/177/1894 492/38/1895 494/403/1896
f 464/490/1897 488/266/1898 485/406/1899 460/180/1900
f 463/272/1901 487/8/1902 488/266/1903 464/490/1904
f 461/386/1905 486/368/1906 487/8/1907 463/272/1908
f 462/205/1909 494/403/1910 486/368/1911 461/386/1912
f 447/182/1913 491/158/1914 492/38/1915 451/177/1916
f 313/367/1917 381/495/1918 489/34/1919 481/438/1920
f 449/407/1921 445/85/1922 473/601/1923 476/436/1924
f 448/581/1925 449/407/1926 476/436/1927 475/265/1928
f 446/267/1929 448/581/1930 475/265/1931 474/84/1932
f 447/182/1933 446/267/1934 474/84/1935 491/158/1936
f 477/419/1937 429/301/1938 192/30/1939 188/256/1940
f 385/628/1941 433/239/1942 489/34/1943 381/495/1944
f 382/62/1945 465/513/1946 431/203/1947 432/72/1948
f 189/139/1949 428/426/1950 427/64/1951 450/463/1952
f 189/139/1953 193/81/1954 430/127/1955 428/426/1956
f 382/62/1957 432/72/1958 434/108/1959 386/271/1960
f 416/243/1961 386/271/1962 434/108/1963 436/600/1964
f 416/243/1965 436/600/1966 430/127/1967 193/81/1968
f 429/301/1969 477/419/1970 450/463/1971 427/64/1972
f 311/45/1973 312/2/1974 480/6/1975 479/152/1976
f 269/225/1977 396/320/1978 513/636/1979 527/534/1980
f 290/405/1981 398/509/1982 514/223/1983 528/620/1984
f 195/119/1985 517/336/1986 530/154/1987 221/263/1988
f 305/96/1989 531/234/1990 532/390/1991 320/596/1992
f 335/471/1993 529/429/1994 530/327/1995 341/7/1996
f 290/405/1997 528/620/1998 531/234/1999 305/96/2000
f 237/508/2001 525/557/2002 526/173/2003 248/12/2004
f 228/500/2005 524/93/2006 525/557/2007 237/508/2008
f 220/186/2009 523/427/2010 524/93/2011 228/500/2012
f 211/63/2013 515/252/2014 523/427/2015 220/186/2016
f 248/12/2017 526/173/2018 527/488/2019 336/275/2020
f 320/596/2021 532/390/2022 529/429/2023 335/471/2024
f 201/632/2025 516/229/2026 522/592/2027 200/423/2028
f 200/423/2029 522/592/2030 521/112/2031 199/348/2032
f 199/348/2033 521/112/2034 520/299/2035 198/594/2036
f 198/594/2037 520/299/2038 519/617/2039 197/349/2040
f 197/349/2041 519/617/2042 518/46/2043 196/76/2044
f 196/76/2045 518/46/2046 517/336/2047 195/119/2048
f 202/360/2049 515/90/2050 516/410/2051 201/286/2052
f 76/206/2053 507/521/2054 513/636/2055 396/320/2056
f 97/259/2057 508/571/2058 514/223/2059 398/509/2060
f 2/306/2061 28/364/2062 510/489/2063 497/51/2064
f 112/593/2065 127/41/2066 512/446/2067 511/374/2068
f 142/358/2069 148/398/2070 510/303/2071 509/155/2072
f 97/259/2073 112/593/2074 511/374/2075 508/571/2076
f 44/201/2077 55/258/2078 506/48/2079 505/215/2080
f 35/439/2081 44/201/2082 505/215/2083 504/183/2084
f 27/469/2085 35/439/2086 504/183/2087 503/238/2088
f 18/455/2089 27/469/2090 503/238/2091 495/380/2092
f 55/258/2093 143/343/2094 507/553/2095 506/48/2096
f 127/41/2097 142/358/2098 509/155/2099 512/446/2100
f 8/59/2101 7/640/2102 502/224/2103 496/583/2104
f 7/640/2105 6/18/2106 501/337/2107 502/224/2108
f 6/18/2109 5/305/2110 500/630/2111 501/337/2112
f 5/305/2113 4/58/2114 499/532/2115 500/630/2116
f 4/58/2117 3/176/2118 498/353/2119 499/532/2120
f 3/176/2121 2/306/2122 497/51/2123 498/353/2124
f 9/10/2125 8/540/2126 496/202/2127 495/516/2128

`


export let cylinderString: string = 
`
g default
v 0.000000 0.000000 -1.000000
v 0.195090 0.000000 -0.980785
v 0.382683 0.000000 -0.923880
v 0.555570 0.000000 -0.831470
v 0.707107 0.000000 -0.707107
v 0.831470 0.000000 -0.555570
v 0.923880 0.000000 -0.382683
v 0.980785 0.000000 -0.195090
v 1.000000 0.000000 0.000000
v 0.980785 0.000000 0.195090
v 0.923880 0.000000 0.382683
v 0.831470 0.000000 0.555570
v 0.707107 0.000000 0.707107
v 0.555570 0.000000 0.831470
v 0.382683 0.000000 0.923880
v 0.195090 0.000000 0.980785
v 0.000000 0.000000 1.000000
v -0.195091 0.000000 0.980785
v -0.382684 0.000000 0.923879
v -0.555571 0.000000 0.831469
v -0.707107 0.000000 0.707106
v -0.831470 0.000000 0.555570
v -0.923880 0.000000 0.382683
v -0.980785 0.000000 0.195089
v -1.000000 0.000000 -0.000001
v -0.980785 0.000000 -0.195091
v -0.923879 0.000000 -0.382684
v -0.831469 0.000000 -0.555571
v -0.707106 0.000000 -0.707108
v -0.555569 0.000000 -0.831470
v -0.382682 0.000000 -0.923880
v -0.195089 0.000000 -0.980786
v 0.000001 2.000000 -0.735735
v 0.143536 2.000000 -0.721598
v 0.281555 2.000000 -0.679730
v 0.408754 2.000000 -0.611741
v 0.520244 2.000000 -0.520242
v 0.611742 2.000000 -0.408752
v 0.679731 2.000000 -0.281553
v 0.721599 2.000000 -0.143533
v 0.735735 2.000000 0.000001
v 0.721598 2.000000 0.143536
v 0.679730 2.000000 0.281555
v 0.611741 2.000000 0.408753
v 0.520243 2.000000 0.520243
v 0.408752 2.000000 0.611741
v 0.281554 2.000000 0.679730
v 0.143535 2.000000 0.721598
v 0.000001 2.000000 0.735735
v -0.143534 2.000000 0.721598
v -0.281553 2.000000 0.679731
v -0.408751 2.000000 0.611742
v -0.520242 2.000000 0.520244
v -0.611740 2.000000 0.408754
v -0.679729 2.000000 0.281555
v -0.721598 2.000000 0.143537
v -0.735735 2.000000 0.000003
v -0.721599 2.000000 -0.143532
v -0.679732 2.000000 -0.281550
v -0.611744 2.000000 -0.408749
v -0.520246 2.000000 -0.520240
v -0.408756 2.000000 -0.611739
v -0.281558 2.000000 -0.679729
v -0.143540 2.000000 -0.721597
vt 2.240672 -0.000043
vt 2.240671 0.999957
vt 2.124629 0.999957
vt 2.124630 -0.000043
vt 2.008586 0.999957
vt 2.008587 -0.000043
vt 1.892544 0.999957
vt 1.892545 -0.000043
vt 1.776502 0.999957
vt 1.776503 -0.000043
vt 1.660459 0.999957
vt 1.660460 -0.000043
vt 1.544417 0.999957
vt 1.544418 -0.000043
vt 1.428374 0.999957
vt 1.428375 -0.000043
vt 1.312332 0.999957
vt 1.312333 -0.000043
vt 1.196290 0.999958
vt 1.196290 -0.000043
vt 1.080248 0.999958
vt 1.080248 -0.000043
vt 0.964206 0.999958
vt 0.964206 -0.000043
vt 0.848163 0.999958
vt 0.848163 -0.000043
vt 0.732121 0.999958
vt 0.732121 -0.000043
vt 0.616079 0.999958
vt 0.616079 -0.000043
vt 0.500037 0.999958
vt 0.500036 -0.000043
vt 0.383995 0.999958
vt 0.383994 -0.000043
vt 0.267953 0.999958
vt 0.267952 -0.000043
vt 0.151911 0.999958
vt 0.151909 -0.000043
vt 0.035868 0.999958
vt 0.035867 -0.000043
vt -0.080174 0.999958
vt -0.080175 -0.000043
vt -0.196216 0.999958
vt -0.196218 -0.000043
vt -0.312258 0.999958
vt -0.312260 -0.000043
vt -0.428300 0.999958
vt -0.428302 -0.000043
vt -0.544343 0.999958
vt -0.544345 -0.000043
vt -0.660385 0.999958
vt -0.660388 -0.000043
vt -0.776427 0.999957
vt -0.776430 -0.000043
vt -0.892469 0.999957
vt -0.892473 -0.000043
vt -1.008511 0.999957
vt -1.008515 -0.000043
vt -1.124553 0.999957
vt -1.124557 -0.000043
vt -1.240595 0.999957
vt -1.240600 -0.000043
vt -1.356637 0.999957
vt -1.356642 -0.000043
vt 2.356714 -0.000043
vt 2.356719 0.999957
vn 0.000000 0.000000 -1.000000
vn 0.000000 0.000000 -1.000000
vn 0.195077 0.000000 -0.980788
vn 0.000000 0.000000 -1.000000
vn 0.195077 0.000000 -0.980788
vn 0.195077 0.000000 -0.980788
vn 0.195077 0.000000 -0.980788
vn 0.195077 0.000000 -0.980788
vn 0.382682 0.000000 -0.923880
vn 0.195077 0.000000 -0.980788
vn 0.382682 0.000000 -0.923880
vn 0.382682 0.000000 -0.923880
vn 0.382682 0.000000 -0.923880
vn 0.382682 0.000000 -0.923880
vn 0.555573 0.000000 -0.831468
vn 0.382682 0.000000 -0.923880
vn 0.555573 0.000000 -0.831468
vn 0.555573 0.000000 -0.831468
vn 0.555573 0.000000 -0.831468
vn 0.555573 0.000000 -0.831468
vn 0.707107 0.000000 -0.707107
vn 0.555573 0.000000 -0.831468
vn 0.707107 0.000000 -0.707107
vn 0.707107 0.000000 -0.707107
vn 0.707107 0.000000 -0.707107
vn 0.707107 0.000000 -0.707107
vn 0.831468 0.000000 -0.555573
vn 0.707107 0.000000 -0.707107
vn 0.831468 0.000000 -0.555573
vn 0.831468 0.000000 -0.555573
vn 0.831468 0.000000 -0.555573
vn 0.831468 0.000000 -0.555573
vn 0.923880 0.000000 -0.382682
vn 0.831468 0.000000 -0.555573
vn 0.923880 0.000000 -0.382682
vn 0.923880 0.000000 -0.382682
vn 0.923880 0.000000 -0.382682
vn 0.923880 0.000000 -0.382682
vn 0.980788 0.000000 -0.195077
vn 0.923880 0.000000 -0.382682
vn 0.980788 0.000000 -0.195077
vn 0.980788 0.000000 -0.195077
vn 0.980788 0.000000 -0.195077
vn 0.980788 0.000000 -0.195077
vn 1.000000 0.000000 0.000000
vn 0.980788 0.000000 -0.195077
vn 1.000000 0.000000 0.000000
vn 1.000000 0.000000 0.000000
vn 1.000000 0.000000 0.000000
vn 1.000000 0.000000 0.000000
vn 0.980788 0.000000 0.195077
vn 1.000000 0.000000 0.000000
vn 0.980788 0.000000 0.195077
vn 0.980788 0.000000 0.195077
vn 0.980788 0.000000 0.195077
vn 0.980788 0.000000 0.195077
vn 0.923880 0.000000 0.382682
vn 0.980788 0.000000 0.195077
vn 0.923880 0.000000 0.382682
vn 0.923880 0.000000 0.382682
vn 0.923880 0.000000 0.382682
vn 0.923880 0.000000 0.382682
vn 0.831468 0.000000 0.555573
vn 0.923880 0.000000 0.382682
vn 0.831468 0.000000 0.555573
vn 0.831468 0.000000 0.555573
vn 0.831468 0.000000 0.555573
vn 0.831468 0.000000 0.555573
vn 0.707107 0.000000 0.707107
vn 0.831468 0.000000 0.555573
vn 0.707107 0.000000 0.707107
vn 0.707107 0.000000 0.707107
vn 0.707107 0.000000 0.707107
vn 0.707107 0.000000 0.707107
vn 0.555573 0.000000 0.831468
vn 0.707107 0.000000 0.707107
vn 0.555573 0.000000 0.831468
vn 0.555573 0.000000 0.831468
vn 0.555573 0.000000 0.831468
vn 0.555573 0.000000 0.831468
vn 0.382682 0.000000 0.923880
vn 0.555573 0.000000 0.831468
vn 0.382682 0.000000 0.923880
vn 0.382682 0.000000 0.923880
vn 0.382682 0.000000 0.923880
vn 0.382682 0.000000 0.923880
vn 0.195077 0.000000 0.980788
vn 0.382682 0.000000 0.923880
vn 0.195077 0.000000 0.980788
vn 0.195077 0.000000 0.980788
vn 0.195077 0.000000 0.980788
vn 0.195077 0.000000 0.980788
vn 0.000000 0.000000 1.000000
vn 0.195077 0.000000 0.980788
vn 0.000000 0.000000 1.000000
vn 0.000000 0.000000 1.000000
vn 0.000000 0.000000 1.000000
vn 0.000000 0.000000 1.000000
vn -0.195077 0.000000 0.980788
vn 0.000000 0.000000 1.000000
vn -0.195077 0.000000 0.980788
vn -0.195077 0.000000 0.980788
vn -0.195077 0.000000 0.980788
vn -0.195077 0.000000 0.980788
vn -0.382682 0.000000 0.923880
vn -0.195077 0.000000 0.980788
vn -0.382682 0.000000 0.923880
vn -0.382682 0.000000 0.923880
vn -0.382682 0.000000 0.923880
vn -0.382682 0.000000 0.923880
vn -0.555573 0.000000 0.831468
vn -0.382682 0.000000 0.923880
vn -0.555573 0.000000 0.831468
vn -0.555573 0.000000 0.831468
vn -0.555573 0.000000 0.831468
vn -0.555573 0.000000 0.831468
vn -0.707107 0.000000 0.707107
vn -0.555573 0.000000 0.831468
vn -0.707107 0.000000 0.707107
vn -0.707107 0.000000 0.707107
vn -0.707107 0.000000 0.707107
vn -0.707107 0.000000 0.707107
vn -0.831468 0.000000 0.555573
vn -0.707107 0.000000 0.707107
vn -0.831468 0.000000 0.555573
vn -0.831468 0.000000 0.555573
vn -0.831468 0.000000 0.555573
vn -0.831468 0.000000 0.555573
vn -0.923880 0.000000 0.382682
vn -0.831468 0.000000 0.555573
vn -0.923880 0.000000 0.382682
vn -0.923880 0.000000 0.382682
vn -0.923880 0.000000 0.382682
vn -0.923880 0.000000 0.382682
vn -0.980788 0.000000 0.195077
vn -0.923880 0.000000 0.382682
vn -0.980788 0.000000 0.195077
vn -0.980788 0.000000 0.195077
vn -0.980788 0.000000 0.195077
vn -0.980788 0.000000 0.195077
vn -1.000000 0.000000 0.000000
vn -0.980788 0.000000 0.195077
vn -1.000000 0.000000 0.000000
vn -1.000000 0.000000 0.000000
vn -1.000000 0.000000 0.000000
vn -1.000000 0.000000 0.000000
vn -0.980788 0.000000 -0.195077
vn -1.000000 0.000000 0.000000
vn -0.980788 0.000000 -0.195077
vn -0.980788 0.000000 -0.195077
vn -0.980788 0.000000 -0.195077
vn -0.980788 0.000000 -0.195077
vn -0.923880 0.000000 -0.382682
vn -0.980788 0.000000 -0.195077
vn -0.923880 0.000000 -0.382682
vn -0.923880 0.000000 -0.382682
vn -0.923880 0.000000 -0.382682
vn -0.923880 0.000000 -0.382682
vn -0.831468 0.000000 -0.555573
vn -0.923880 0.000000 -0.382682
vn -0.831468 0.000000 -0.555573
vn -0.831468 0.000000 -0.555573
vn -0.831468 0.000000 -0.555573
vn -0.831468 0.000000 -0.555573
vn -0.707107 0.000000 -0.707107
vn -0.831468 0.000000 -0.555573
vn -0.707107 0.000000 -0.707107
vn -0.707107 0.000000 -0.707107
vn -0.707107 0.000000 -0.707107
vn -0.707107 0.000000 -0.707107
vn -0.555573 0.000000 -0.831468
vn -0.707107 0.000000 -0.707107
vn -0.555573 0.000000 -0.831468
vn -0.555573 0.000000 -0.831468
vn -0.555573 0.000000 -0.831468
vn -0.555573 0.000000 -0.831468
vn -0.382682 0.000000 -0.923880
vn -0.555573 0.000000 -0.831468
vn -0.382682 0.000000 -0.923880
vn -0.382682 0.000000 -0.923880
vn -0.382682 0.000000 -0.923880
vn -0.382682 0.000000 -0.923880
vn -0.195077 0.000000 -0.980788
vn -0.382682 0.000000 -0.923880
vn -0.195077 0.000000 -0.980788
vn -0.195077 0.000000 -0.980788
vn 0.000000 0.000000 -1.000000
vn 0.000000 0.000000 -1.000000
vn -0.195077 0.000000 -0.980788
vn 0.000000 0.000000 -1.000000
vn -0.195077 0.000000 -0.980788
vn -0.195077 0.000000 -0.980788
s off
g Mesh
usemtl initialShadingGroup
f 1/1/1 33/2/2 34/3/3
f 1/1/4 34/3/5 2/4/6
f 2/4/7 34/3/8 35/5/9
f 2/4/10 35/5/11 3/6/12
f 3/6/13 35/5/14 36/7/15
f 3/6/16 36/7/17 4/8/18
f 4/8/19 36/7/20 37/9/21
f 4/8/22 37/9/23 5/10/24
f 5/10/25 37/9/26 38/11/27
f 5/10/28 38/11/29 6/12/30
f 6/12/31 38/11/32 39/13/33
f 6/12/34 39/13/35 7/14/36
f 7/14/37 39/13/38 40/15/39
f 7/14/40 40/15/41 8/16/42
f 8/16/43 40/15/44 41/17/45
f 8/16/46 41/17/47 9/18/48
f 9/18/49 41/17/50 42/19/51
f 9/18/52 42/19/53 10/20/54
f 10/20/55 42/19/56 43/21/57
f 10/20/58 43/21/59 11/22/60
f 11/22/61 43/21/62 44/23/63
f 11/22/64 44/23/65 12/24/66
f 12/24/67 44/23/68 45/25/69
f 12/24/70 45/25/71 13/26/72
f 13/26/73 45/25/74 46/27/75
f 13/26/76 46/27/77 14/28/78
f 14/28/79 46/27/80 47/29/81
f 14/28/82 47/29/83 15/30/84
f 15/30/85 47/29/86 48/31/87
f 15/30/88 48/31/89 16/32/90
f 16/32/91 48/31/92 49/33/93
f 16/32/94 49/33/95 17/34/96
f 17/34/97 49/33/98 50/35/99
f 17/34/100 50/35/101 18/36/102
f 18/36/103 50/35/104 51/37/105
f 18/36/106 51/37/107 19/38/108
f 19/38/109 51/37/110 52/39/111
f 19/38/112 52/39/113 20/40/114
f 20/40/115 52/39/116 53/41/117
f 20/40/118 53/41/119 21/42/120
f 21/42/121 53/41/122 54/43/123
f 21/42/124 54/43/125 22/44/126
f 22/44/127 54/43/128 55/45/129
f 22/44/130 55/45/131 23/46/132
f 23/46/133 55/45/134 56/47/135
f 23/46/136 56/47/137 24/48/138
f 24/48/139 56/47/140 57/49/141
f 24/48/142 57/49/143 25/50/144
f 25/50/145 57/49/146 58/51/147
f 25/50/148 58/51/149 26/52/150
f 26/52/151 58/51/152 59/53/153
f 26/52/154 59/53/155 27/54/156
f 27/54/157 59/53/158 60/55/159
f 27/54/160 60/55/161 28/56/162
f 28/56/163 60/55/164 61/57/165
f 28/56/166 61/57/167 29/58/168
f 29/58/169 61/57/170 62/59/171
f 29/58/172 62/59/173 30/60/174
f 30/60/175 62/59/176 63/61/177
f 30/60/178 63/61/179 31/62/180
f 31/62/181 63/61/182 64/63/183
f 31/62/184 64/63/185 32/64/186
f 33/2/187 1/1/188 32/65/189
f 33/2/190 32/65/191 64/66/192
`;



// WEBPACK FOOTER //
// ./src/globals.ts